import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Box,
  Button,
  Card,
  Checkbox,
  createTheme,
  Divider,
  FormControlLabel,
  Grid,
  ThemeProvider,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Stack,
  Stepper,
  Step,
  StepLabel,
  Radio,
  TableCell,
  TableRow,
  TableHead,
  Table,
  IconButton,
  Paper,
  TableBody,
  TableContainer,
  DialogContentText,
  Switch,
} from "@mui/material";
import {
  LocalShipping as LocalShippingIcon,
  CheckCircle as CheckCircleIcon,
  Paid as PaidIcon,
  TrendingUp as TrendingUpIcon,
  DirectionsCar as DirectionsCarIcon,

  Person as PersonIcon,
  CalendarToday as CalendarTodayIcon,
  LocationOn as LocationOnIcon,
  Info as InfoIcon,
  Description as DescriptionIcon,
  Close as CloseIcon,
  Verified as VerifiedIcon,
  Cancel as CancelIcon,
} from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faCheck,
  faCloudArrowUp,
  faFileExport,
  faFileImport,
  faPen,
  faPlus,
  faTrash,
  faRetweet
} from "@fortawesome/free-solid-svg-icons";
import SeparatorBreadcrumbs from "../../Components/SeparatorBreadcrumbs";
import ButtonAttribute from "../../Components/ButtonAttribute";
import DataGrid2Table from "../../Components/TableData";
import BasicModal from "../../Components/BasicModel";
import axios from "axios";
import { API } from "../../API/api";
import TextInputMui from "../../Components/TextInputMui";
import AlertBar from "../../Components/AlertBar";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import dayjs from 'dayjs';
import CustomizedProgressBars from "../../Components/CustomizedProgressBars";
import DateTimePickerComponent from "../../Components/DateTimePicker";
import AutocompleteComboBox from "../../Components/AutocompleteComboBox";
import CustomDrawer from "../../Components/Drawer";
import TokenExpired from "../../Components/TokenExpired";
import { useAuth } from "../../Context/AuthContext";
import { logOperation } from "../../API/logOperation";
import SelectChips from "../../Components/SelectChips";
import TextInputMuiMult from "../../Components/TextInputMuiMult";
const theme = createTheme({
  typography: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h4: {
      fontWeight: 700,
      letterSpacing: '-0.025em'
    },
    h6: {
      fontWeight: 600,
      letterSpacing: '-0.025em'
    },
    body1: {
      fontWeight: 500
    }
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#3b82f6',
      light: '#8b9eff',
      dark: '#2563eb'
    },
    secondary: {
      main: '#8b5cf6',
      light: '#a78bfa',
      dark: '#7c3aed'
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff'
    },
    text: {
      primary: '#1f2937',
      secondary: '#6b7280'
    }
  },
  shape: {
    borderRadius: 8
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        }
      }
    }
  }
});




export default function Voyages() {
  const [isLoading, setIsLoading] = useState(0);
  const [importStatus, setImportStatus] = useState("idle");
  const [Voyages, setVoyages] = useState([]);
  const [openAjouterVoyage, setOpenAjouterVoyage] = React.useState(false);
  const [rowsSelected, setRowsSelected] = React.useState({});
  const handleOpen = () => setOpenAjouterVoyage(true);
  const handleClose = () => {
    setOpenAjouterVoyage(false);
    setNewVoyage({
      Client_facturation: "",
      ID_Vehicule: "",
      Date_chargement: dayjs().format('DD-MM-YYYY HH:mm'), // ✅ Correct
      Date_déchargement: "",
      Expediteur: "",
      Destinataire: "",
      Coût_Total: "",
      prix_total_voyage: "",
      Statut: "Réserver",
      Nombre_palettes: "",
      Type_de_moyen: "",
      Type_Voyage: "",
      Fournisseur: "",
      N_CMR: "",
      Scellés_Douane: "",
      BL_Number: "",
      Prix_de_Moyen: "",
      Immobilisation: "",
      N_jours: "",
      Prix_Immobilisation: "",
      Prestation: "",
      Prix_Prestation: "",
      ID_Tarification: "",
      Motif_Annulation: "",
      Commentaire_Annulation: "",
      ID_Tarification: "",
    });
  };
  const [Permissions, setPermissions] = useState([]);
  const [role, setRole] = useState([]);

  {/* modifier Voyage */ }
  const [openModifierVoyage, setOpenModifierVoyage] = React.useState(false);
  const handleOpenModifier = async () => {
    const selectedRows = JSON.parse(localStorage.getItem("selectedRows") || "[]");
    if (selectedRows.length > 0) {
      setOpenModifierVoyage(true);
      setRowsSelected(selectedRows);

      setModifierVoyage(selectedRows[0]);
      if (selectedRows[0].ID_Vehicule !== null && selectedRows[0].Fournisseur === null) {
        setCheckedModifier({
          Interne: true,
          Externe: false
        });
        setSelectedTypeModifer('Interne');
      }
      if (selectedRows[0].ID_Vehicule === null && selectedRows[0].Fournisseur !== null) {

        setCheckedModifier({
          Interne: false,
          Externe: true
        });
        setSelectedTypeModifer('Externe');
      }

      setVillesTarificationByClient(villesTarification.filter(ville => ville.ID_Client === selectedRows[0].ID_Client));

    } else {
      setAlertOpenSelectedModifier(true);
    }
  };

  const handleCloseModifier = () => {
    setOpenModifierVoyage(false);
  };

  const [openModifierLignesVoyages, setOpenModifierLignesVoyages] = useState(false);
  const handleOpenModifierLignesVoyages = () => {
    setOpenModifierLignesVoyages(true);
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);
    console.log(modifierVoyage.ID_Voyage);
    GetLignesVoyages(parsedAuthState.token, modifierVoyage.ID_Voyage);

  }
  const handleCloseModifierLignesVoyages = () => {
    setOpenModifierLignesVoyages(false);
  }

  const [alertOpenSelectedModifier, setAlertOpenSelectedModifier] = useState(false);
  const handleAlertCloseSelectedModifier = () => {
    setAlertOpenSelectedModifier(false);
  };
  const [alertOpenNotModiferRow, setAlertOpenNotModiferRow] = useState(false);
  const handleAlertCloseNotModiferRow = () => {
    setAlertOpenNotModiferRow(false);
  };
  const handleAlertOpenNotModiferRow = () => {
    setAlertOpenNotModiferRow(true);
  };
  const [alertOpenUpdatedVoyage, setAlertOpenUpdatedVoyage] = useState(false);
  const handleAlertCloseUpdatedVoyage = () => {
    setAlertOpenUpdatedVoyage(false);
  };
  const handleAlertOpenUpdatedVoyage = () => {
    setAlertOpenUpdatedVoyage(true);
  };




  // Build API payload from form state

  const toSlashList = (val) => {
    if (val == null || val === "") return null;
    const arr = Array.isArray(val) ? val : String(val).split(/[,\s;|/]+/);
    const seen = new Set();
    const out = [];
    for (const raw of arr) {
      const tok = String(raw).trim();
      if (!tok) continue;
      if (seen.has(tok)) continue;
      seen.add(tok);
      out.push(tok); // keep original case
    }
    return out.length ? out.join("/").slice(0, 255) : null;
  };
  const buildVoyagePayload = (state) => ({
    Client_facturation: state.Client_facturation,
    ID_Vehicule: state.ID_Vehicule || null,
    Date_chargement: isoOrNull(state.Date_chargement),
    Date_déchargement: isoOrNull(state.Date_déchargement),

    Expediteur: strOrNull(state.Expediteur),
    Destinataire: strOrNull(state.Destinataire),

    Coût_Total: numOrNull(state.Coût_Total),
    prix_total_voyage: numOrNull(state.prix_total_voyage),

    Statut: strOrNull(state.Statut) || "Réserver",
    Nombre_palettes: intOrNull(state.Nombre_palettes),
    Type_de_moyen: strOrNull(state.Type_de_moyen),
    Type_Voyage: strOrNull(state.Type_Voyage),
    Fournisseur: state.Fournisseur ?? null,

    // slash-separated strings
    N_CMR: toSlashList(state.N_CMR),
    N_CMR_RT: toSlashList(state.N_CMR_RT),
    N_DUM: toSlashList(state.N_DUM),
    N_DUM_RT: toSlashList(state.N_DUM_RT),
    Scellés_Douane: serializeIds(state.Scellés_Douane), // IDs → "2/5/8"

    BL_Number: strOrNull(state.BL_Number),
    Immobilisation: strOrNull(state.Immobilisation),
    N_jours: intOrNull(state.N_jours),
    Prix_Immobilisation: numOrNull(state.Prix_Immobilisation),
    Prestation: strOrNull(state.Prestation),
    Type_de_prestation: strOrNull(state.Type_de_prestation),
    Prix_Prestation: numOrNull(state.Prix_Prestation),
    ID_Tarification: state.ID_Tarification ?? null,
  });
  // ---------- MODIFY (same normalization as add) ----------

  const isVoyageChanged = (original, updated) => {
    return JSON.stringify(original) !== JSON.stringify(updated);
  };
  const handleOpenModifierOneVoyage = async () => {
    const required = [
      { key: "Client_facturation", label: "Client facturation" },
      { key: "Date_chargement", label: "Date de chargement" },
      { key: "Expediteur", label: "Expéditeur" },
      { key: "Destinataire", label: "Destinataire" },
    ];

    const missing = required
      .filter(({ key }) => !modifierVoyage[key])
      .map(({ label }) => label);

    if (missing.length) {
      setErrorsModifer({
        error: true,
        message: `Veuillez remplir : ${missing.join(", ")}`,
      });
      return;
    }

    // ✅ Compare with original selected row
    if (!isVoyageChanged(rowsSelected[0], modifierVoyage)) {
      toast.warning(
        "Aucun changement détecté, annulation de la modification.",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
      return;
    }

    try {
      const token = JSON.parse(
        sessionStorage.getItem("authLocalstorage")
      )?.token;

      const payload = buildVoyagePayload(modifierVoyage);

      await axios.put(
        `${API}/voyages/${modifierVoyage.ID_Voyage}`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      handleAlertOpenUpdatedVoyage();
      handleCloseModifier();
      await fetchVoyages(token);
      setErrorsModifer({ error: false, message: "" });

    } catch (error) {
      const message =
        error?.response?.data?.message ||
        (error.request
          ? "Erreur de connexion au serveur"
          : error.message) ||
        "Une erreur est survenue";

      setErrorsModifer({ error: true, message });
      toast.error("Erreur lors de la modification du voyage.");
    }
  };


  {
    /* end modifier Voyage */
  }


  /* Importation de voyages */
  const [errors, setErrors] = useState({
    error: false,
    message: "",
  });
  const [errorsModifer, setErrorsModifer] = useState({
    error: false,
    message: "",
  })
  const [alertOpen, setAlertOpen] = useState(false);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };
  const handleSelectionChangeID_Client = (keyField) => {
    setNewVoyage((prev) => ({
      ...prev,
      Client_facturation: keyField,
    }));
    setVillesTarificationByClient(villesTarification.filter(ville => ville.ID_Client == keyField));
  };
  const handleModifierSelectionChangeClient = (key, value) => {
    setModifierVoyage((prev) => ({
      ...prev,
      Client_facturation: key, // Assign the selected key to ID_Client
    }));
    setVillesTarificationByClient(villesTarification.filter(ville => ville.ID_Client == key));
  };
  const handleSelectionChangeVehicule = (selectedId) => {
    setNewVoyage((prev) => ({
      ...prev,
      ID_Vehicule: selectedId,
    }));
  };

  const handleSelectionChangeFournisseur = (selectedId) => {
    setNewVoyage((prev) => ({
      ...prev,
      Fournisseur: selectedId,
    }));
  };
  const handleModifierSelectionChangeFournisseur = (selectedId) => {
    setModifierVoyage((prev) => ({
      ...prev,
      Fournisseur: selectedId,
    }));
  };
  const handleModifierSelectionChangeVehicule = (key, value) => {
    setModifierVoyage((prev) => ({
      ...prev,
      ID_Vehicule: key, // Assign the selected key to ID_Client
    }));
  };


  const [newVoyage, setNewVoyage] = useState({
    Client_facturation: "",
    ID_Vehicule: "",
    Date_chargement: dayjs().format('DD-MM-YYYY HH:mm'), // ✅ Correct
    Date_déchargement: "",
    Expediteur: "",
    Destinataire: "",
    Coût_Total: "",
    prix_total_voyage: "",
    Statut: "Réserver",
    Nombre_palettes: "",
    Type_de_moyen: "",
    Type_Voyage: "",
    Fournisseur: "",
    N_CMR: "",
    N_CMR_RT: "",
    N_DUM_RT: "",
    N_DUM: "",
    Scellés_Douane: "",
    BL_Number: "",
    Prix_de_Moyen: "",
    Immobilisation: "",
    N_jours: "",
    Prix_Immobilisation: "",
    Prestation: "",
    Type_de_prestation: "",
    Prix_Prestation: "",
    ID_Tarification: "",
    Motif_Annulation: "",
    Commentaire_Annulation: "",
  });
  const [originalVoyage, setOriginalVoyage] = useState(null);
  const [modifierVoyage, setModifierVoyage] = useState({
    ID_Voyage: null,
    Client_facturation: null,       // ✅ colonne exacte en base
    ID_Vehicule: null,
    Date_chargement: "",            // ✅ nom correct
    Date_déchargement: "",          // ✅ nom correct
    Expediteur: "",
    Destinataire: "",
    Coût_Total: null,
    prix_total_voyage: null,
    Statut: "",
    Nombre_palettes: null,
    Type_de_moyen: "",
    Type_Voyage: "",
    Fournisseur: "",
    N_CMR: "",
    N_CMR_RT: "",
    N_DUM_RT: "",
    N_DUM: "",
    Scellés_Douane: "",
    BL_Number: "",
    Prix_de_Moyen: null,
    Immobilisation: "",
    N_jours: null,
    Prix_Immobilisation: null,
    Prestation: "",
    Type_de_prestation: "",
    Prix_Prestation: null,
    ID_Tarification: null,
    Motif_Annulation: "",
    Commentaire_Annulation: "",
    ID_Tarification: null,
  });


  {
    /* Delete Voyage */
  }
  const [alertOpenDeletedVoyage, setAlertOpenDeletedVoyage] = useState(false);
  const handleAlertCloseDeletedVoyage = () => {
    setAlertOpenDeletedVoyage(false);
  };
  const handleAlertOpenDeletedVoyage = () => {
    setAlertOpenDeletedVoyage(true);
  };
  const [alertOpenMultiDeletedVoyage, setAlertMultiOpenDeletedVoyage] =
    useState(false);
  const handleAlertMultiCloseDeletedVoyage = () => {
    setAlertMultiOpenDeletedVoyage(false);
  };
  const handleAlertMultiOpenDeletedVoyage = () => {
    setAlertMultiOpenDeletedVoyage(true);
  };
  const [openDeleteVoyage, setOpenDeleteVoyage] = useState(false);
  const [alertOpenPasswordNotValid, setAlertOpenPasswordNotValid] =
    useState(false);
  const handleAlertClosePasswordNotValid = () => {
    setAlertOpenPasswordNotValid(false);
  };
  const handleAlertOpenPasswordNotValid = () => {
    setAlertOpenPasswordNotValid(true);
  };
  const handleOpenDeleteVoyage = () => {
    const selectedRows = JSON.parse(
      localStorage.getItem("selectedRows"),
      null,
      2
    );
    if (selectedRows.length > 0) {
      setOpenDeleteVoyage(true);
      setRowsSelected(selectedRows);
      setModifierVoyage(selectedRows[0]);
    } else {
      setAlertOpenSelectedModifier(true);
    }
  };
  const handleCloseDeleteVoyage = () => {
    setOpenDeleteVoyage(false);
  };
  const handleDeleteVoyage = async () => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);

    const ID = modifierVoyage.ID_Voyage;

    try {
      // Make the DELETE request
      const response = await axios.delete(`${API}/voyages/${ID}`, {
        headers: { Authorization: `Bearer ${parsedAuthState.token}` },
      });

      // Handle the response

      handleCloseDeleteVoyage();
      handleAlertOpenDeletedVoyage();
      updateScellesUtilise(modifierVoyage.Scellés_Douane, parsedAuthState.token, 0);
      logOperation({
        action: "Suppression",
        description: `Suppression de Voyage ID : ${ID}`,
        token: parsedAuthState.token,
      });
      GetScelles(parsedAuthState.token);
      fetchVoyages(parsedAuthState.token);
      //window.location.reload();
    } catch (error) {
      // Handle errors
      if (error.response) {
        // The request was made and the server responded with a status code that falls out of the range of 2xx
        console.error("Error Response:", error.response.data.error);
      } else if (error.request) {
        // The request was made but no response was received
        console.error("Error Request:", error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error Message:", error.message);
      }
    }
  };
  const handleDeleteMultiVoyages = async () => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);
    const token = parsedAuthState.token;

    try {
      const scellesIds = rowsSelected
        .flatMap((row) =>
          String(row.Scellés_Douane || "")
            .split("/")
            .map((id) => id.trim())
        )
        .filter(Boolean);

      console.log("scellesIds corrected:", scellesIds);

      if (scellesIds.length > 0) {
        await updateScellesUtilise(scellesIds, token, 0);
      }

      await Promise.all(
        rowsSelected.map((row) =>
          axios.delete(`${API}/voyages/${row.ID_Voyage}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
        )
      );

      handleCloseDeleteVoyage();
      handleAlertMultiOpenDeletedVoyage();

      GetScelles(token);
      fetchVoyages(token);
    } catch (error) {
      if (error.response) {
        console.error("Error Response:", error.response.data?.error || error.response.data);
      } else if (error.request) {
        console.error("Error Request:", error.request);
      } else {
        console.error("Error Message:", error.message);
      }
    }
  };

  //
  const [selectedType, setSelectedType] = useState('Interne'); // Default to 'Interne'
  const [checked, setChecked] = useState({
    Interne: true,
    Externe: false
  });

  const handleRadioChange = (event) => {
    if (checked.Interne && !checked.Externe) {
      setChecked({
        Interne: false,
        Externe: true
      });
      setSelectedType('Externe');
    }
    if (!checked.Interne && checked.Externe) {
      setChecked({
        Interne: true,
        Externe: false
      });
      setSelectedType('Interne');
    }

  };

  const [selectedTypeModifer, setSelectedTypeModifer] = useState('Interne');
  const [checkedModifier, setCheckedModifier] = useState({
    Interne: true,
    Externe: false
  });

  const handleRadioChangeModifier = (event) => {
    if (checkedModifier.Interne && !checkedModifier.Externe) {
      setCheckedModifier({
        Interne: false,
        Externe: true
      });
      setSelectedTypeModifer('Externe');
    }
    if (!checkedModifier.Interne && checkedModifier.Externe) {
      setCheckedModifier({
        Interne: true,
        Externe: false
      });
      setSelectedTypeModifer('Interne');
    }

  };

  const handleVerificationPassword = () => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);
    const email = parsedAuthState.user.email;
    const password = ConfrimedPassword.password;

    axios
      .post(`${API}/verify-password`, { email, password })
      .then((response) => {
        if (response.data.success) {
          if (rowsSelected.length === 1) {
            handleDeleteVoyage();
          } else {
            handleDeleteMultiVoyages();
          }

          handleCloseConfirmationPassword();
          fetchVoyages(parsedAuthState.token);
        } else {
          // Handle unexpected responses where success is false
          setConfirmedPassword({
            errors: true,
          });
          console.error("Password verification failed:", response.data);
          handleAlertOpenPasswordNotValid();
        }
      })
      .catch((error) => {
        // Handle errors from the server or network issues
        if (error.response) {
          // Server responded with a status other than 2xx
          console.error("Error response:", error.response.data);
          setConfirmedPassword({
            errors: true,
          });
          handleAlertOpenPasswordNotValid();
        } else if (error.request) {
          // Request was made but no response received
          console.error("No response received:", error.request);
        } else {
          // Something else happened
          console.error("Error setting up request:", error.message);
        }
      });
  };

  const [VoyageStatus, SetVoyageStatus] = useState([] || null);
  const [alertVoyageStatusUpadate, setAlertVoyageStatusUpadate] = useState(false);

  const handleAlertOpenStatusUpdate = () => {
    setAlertVoyageStatusUpadate(true);
  }
  const handleCloseAlertStatusUpdate = () => {
    setAlertVoyageStatusUpadate(false);
  }

  const [alertVoyageDejaEnCours, setAlertVoyageDejaEnCours] = useState(false);
  const handleAlertOpenDejaEnCours = () => {
    setAlertVoyageDejaEnCours(true);
  }
  const handleCloseAlertDejaEnCours = () => {
    setAlertVoyageDejaEnCours(false);
  }
  const handleChangeStatus = () => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);
    const ID = VoyageStatus[0].ID_Voyage;
    axios.patch(`${API}/voyages/${ID}/statut`, { Statut: "En cours" }, {
      headers: { Authorization: `Bearer ${parsedAuthState.token}` }
    }).then((response) => {

      handleAlertOpenStatusUpdate();
      fetchVoyages(parsedAuthState.token);
      handleCloseChangeStatuVoyage();

    }).catch((error) => {
      console.error("Error Response:", error.response.data);
    });
  };

  const handleChangeStatusMultiVoyages = async () => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);

    //const ID = modifierVoyage.id;
    try {
      // Make the DELETE request
      const promises = VoyageStatus.map((row) => {
        if (row.Statut == "En cours") {
          handleAlertOpenDejaEnCours();
          return null;
        } else {
          axios.patch(`${API}/voyages/${row.ID_Voyage}`, {
            Statut: "En cours",
          },
            {
              headers: { Authorization: `Bearer ${parsedAuthState.token}` },
            }).then((response) => {
              handleAlertOpenStatusUpdate();
              fetchVoyages(parsedAuthState.token);
              handleCloseChangeStatuVoyage();
            }).catch((error) => {
              console.error("Error Response:", error.response.data.error);
            })
        }
      })

    } catch (error) {
      // Handle errors
      if (error.response) {
        // The request was made and the server responded with a status code that falls out of the range of 2xx
        console.error("Error Response:", error.response.data.error);
      } else if (error.request) {
        // The request was made but no response was received
        console.error("Error Request:", error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error Message:", error.message);
      }
    }

  };


  {
    /* End Delete Voyage */
  }

  {
    /* Begin Extration Voyage */
  }
  const [openExtrationVoyage, setOpenExtrationVoyage] = useState(false);
  const handleCloseExtrationVoyage = () => {
    setOpenExtrationVoyage(false);
  };
  const handleOpenExtrationVoyage = () => {
    setOpenExtrationVoyage(true);
  };
  const [
    alertOpenNotSelectedLineExtration,
    setAlertOpenNotSelectedLineExtration,
  ] = useState(false);
  const handleAlertOpenNotSelectedLineExtration = () => {
    setAlertOpenNotSelectedLineExtration(true);
  };
  const handleAlertCloseNotSelectedLineExtration = () => {
    setAlertOpenNotSelectedLineExtration(false);
  };
  const handleExtrationAllVoyage = () => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);

    if (!Voyages || Voyages.length === 0) {
      console.warn("Aucune donnée de voyage à exporter.");
      return;
    }

    // Mapper les données
    const dataForExcel = Voyages.map((row) => {
      const formattedRow = {};

      columns.forEach((col) => {
        let value = row[col.accessorKey];

        // Format spécifique
        if (col.accessorKey === "est_facture") {
          formattedRow[col.header] = value ? "Oui" : "Non";
        } else if (typeof value === "string" && /^\d{2}-\d{2}-\d{4}( \d{2}:\d{2})?$/.test(value)) {
          // format dd-mm-yyyy => conversion en dd/mm/yyyy
          const [datePart, timePart] = value.split(" ");
          const [dd, mm, yyyy] = datePart.split("-");
          formattedRow[col.header] = `${dd}/${mm}/${yyyy}` + (timePart ? ` ${timePart}` : "");
        } else {
          formattedRow[col.header] = value ?? "";
        }
      });

      return formattedRow;
    });

    // Création de la feuille Excel
    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Voyages");

    // Générer le fichier
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Lancer le téléchargement
    saveAs(blob, "Export_Voyages_Complet.xlsx");

    // Log
    logOperation({
      operation_type: "Extraction",
      entity_type: "Voyage",
      entity_id: parsedAuthState?.user?.id,
      description: "Extraction complète des voyages",
    });
  };

  const handleExtrationSelectionsVoyages = () => {
    const selectedRows = JSON.parse(localStorage.getItem("selectedRows"));

    if (!selectedRows || selectedRows.length === 0) {
      handleAlertOpenNotSelectedLineExtration();
      return;
    }

    const dataForExcel = selectedRows.map((row) => {
      const formattedRow = {};

      columns.forEach((col) => {
        let value = row[col.accessorKey];

        if (col.accessorKey === "est_facture") {
          formattedRow[col.header] = value ? "Oui" : "Non";
        } else if (
          typeof value === "string" &&
          /^\d{2}-\d{2}-\d{4}( \d{2}:\d{2})?$/.test(value)
        ) {
          // Format date : dd-mm-yyyy → dd/mm/yyyy
          const [datePart, timePart] = value.split(" ");
          const [dd, mm, yyyy] = datePart.split("-");
          formattedRow[col.header] =
            `${dd}/${mm}/${yyyy}` + (timePart ? ` ${timePart}` : "");
        } else {
          formattedRow[col.header] = value ?? "";
        }
      });

      return formattedRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sélection Voyages");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "Voyages_Selection.xlsx");

  };
  {
    /* End Extration Voyage */
  }

  {
    /* Begin importation Voyage */
  }
  const [openImportationVoyage, setOpenImportationVoyage] = useState(false);
  const handleCloseImportationVoyage = () => {
    setOpenImportationVoyage(false);
  };
  const handleOpenImportationVoyage = () => {
    setOpenImportationVoyage(true);
  };
  const [alertOpenImport, setAlertOpenImport] = useState(false);
  const handleAlertOpenImport = () => {
    setAlertOpenImport(true);
  };
  const handleCloseAlertImport = () => {
    setAlertOpenImport(false);
  };
  // Function to handle file download
  const handleDownload = () => {
    const filePath = `/ImportVoyages.xlsx`; // Adjust the path and filename as needed
    const link = document.createElement("a");
    link.href = filePath;
    link.download = "ImportVoyages.xlsx"; // Name for the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const triggerFileInput = () => {
    document.getElementById("file-upload").click();
  };

  // Update the file reading part to ensure we're getting dates correctly
  const handleFileImport = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState || "{}");
    const token = parsedAuthState?.token;

    const pad2 = (n) => String(n).padStart(2, "0");
    const formatYmdHms = (d) =>
      `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`;

    const parseNumber = (v) => {
      if (!v) return 0;
      const s = String(v).replace(/\s/g, "").replace(",", ".");
      const n = Number(s);
      return Number.isFinite(n) ? n : 0;
    };

    const parseIntSafe = (v) => Math.trunc(parseNumber(v));

    const parseDateExcel = (value) => {
      if (!value) return null;
      const d = new Date(value);
      return isNaN(d) ? null : d;
    };

    const formatDateOut = (v) => {
      const d = parseDateExcel(v);
      return d ? formatYmdHms(d) : null;
    };

    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array", cellDates: true });

        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(sheet, {
          raw: false,
          defval: "",
        });

        if (!rows.length) {
          toast.error("Le fichier est vide.");
          return;
        }

        /* ===============================
           CHECK REQUIRED COLUMNS
        =============================== */

        const requiredColumns = [
          "Client facturation",
          "ID Vehicule",
          "Date chargement",
          "Expediteur",
        ];

        const fileColumns = Object.keys(rows[0]);

        const missingColumns = requiredColumns.filter(
          (col) => !fileColumns.includes(col)
        );

        if (missingColumns.length > 0) {
          toast.error(
            `Colonnes obligatoires manquantes : ${missingColumns.join(", ")}`
          );
          return;
        }

        /* ===============================
           VALIDATE ROWS BEFORE INSERT
        =============================== */

        const invalidRows = [];
        const validRows = [];

        rows.forEach((row, index) => {
          const missing = requiredColumns.filter(
            (col) => !row[col] || String(row[col]).trim() === ""
          );

          if (missing.length) {
            invalidRows.push({
              line: index + 2,
              columns: missing,
            });
          } else {
            validRows.push({ row, line: index + 2 });
          }
        });

        if (invalidRows.length > 0) {
          const msg = invalidRows
            .map(
              (e1) =>
                `Ligne ${e1.line} → ${e1.columns.join(", ")}`
            )
            .join(" | ");

          toast.error(
            `Import annulé. Erreurs détectées : ${msg}`
          );
          return;
        }

        /* ===============================
           START INSERT
        =============================== */

        setIsLoading(0);
        setImportStatus("processing");

        let successCount = 0;
        let failedCount = 0;
        const successLines = [];
        const failedLines = [];

        for (let i = 0; i < validRows.length; i++) {
          const { row, line } = validRows[i];

          const payload = {
            Client_facturation: parseIntSafe(row["Client facturation"]),
            ID_Vehicule: row["ID Vehicule"],
            Date_chargement: formatDateOut(row["Date chargement"]),
            Date_déchargement: formatDateOut(row["Date déchargement"]),
            Expediteur: row["Expediteur"],
            Destinataire: row["Destinataire"] || "",
            Coût_Total: parseNumber(row["Coût Total"]),
            prix_total_voyage: parseNumber(row["Coût Total"]),
            Statut: row["Statut"] || "Réserver",
            Nombre_palettes: parseIntSafe(row["Nombre palettes"]),
            Type_de_moyen: row["Type de moyen"] || "",
            Type_Voyage: row["Type Voyage"] || "",
            Fournisseur: row["Fournisseur"] || "",
            N_CMR: row["N_CMR"] || "",
            N_CMR_RT: row["N_CMR_RT"] || "",
            N_DUM_RT: row["N_DUM_RT"] || "",
            N_DUM: row["N_DUM"] || "",
            Scellés_Douane: row["Scellés Douane"] || "",
            BL_Number: row["BL Number"] || "",
            Prix_de_Moyen: parseNumber(row["Prix de Moyen"]),
            Immobilisation: row["Immobilisation"] || "Non",
            N_jours: parseIntSafe(row["N jours"]),
            Prix_Immobilisation: parseNumber(row["Prix Immobilisation"]),
            Prestation: row["Prestation"] || "",
            Type_de_prestation: row["Type de prestation"] || "",
            Prix_Prestation: parseNumber(row["Prix Prestation"]),
            ID_Tarification: null,
            Motif_Annulation: row["Motif Annulation"] || "",
            Commentaire_Annulation:
              row["Commentaire Annulation"] || "",
          };

          try {
            await axios.post(`${API}/voyages`, payload, {
              headers: { Authorization: `Bearer ${token}` },
            });

            successCount++;
            successLines.push(line);
          } catch (err) {
            failedCount++;
            failedLines.push(line);
            console.error("Erreur ligne", line, err);
          }

          setIsLoading(
            ((i + 1) / validRows.length) * 100
          );
        }

        /* ===============================
           FINAL RESULT
        =============================== */

        if (failedCount > 0) {
          setImportStatus("error");

          toast.error(
            `Import terminé.

✅ Succès : ${successCount}
❌ Échecs : ${failedCount}

Lignes insérées : ${successLines.join(", ") || "Aucune"}
Lignes échouées : ${failedLines.join(", ") || "Aucune"}`
          );
        } else {
          setImportStatus("success");

          toast.success(
            `Importation réussie !

${successCount} ligne(s) insérée(s)
Lignes : ${successLines.join(", ")}`
          );
        }

        if (token) fetchVoyages(token);

        setTimeout(() => {
          setIsLoading(0);
          setImportStatus("idle");
        }, 4000);

      } catch (err) {
        console.error("Erreur globale import:", err);
        setImportStatus("error");
        toast.error("Erreur inattendue pendant l'import.");
        setIsLoading(0);
      }
    };

    reader.readAsArrayBuffer(file);
  };




  {
    /* end importation Voyage */
  }

  {
    /* Begin Confirm password for delete Voyage */
  }

  const [openConfirmationPassword, setOpenConfirmationPassword] =
    useState(false);
  const handleCloseConfirmationPassword = () => {
    setOpenConfirmationPassword(false);
  };
  const handleOpenConfirmationPassword = () => {
    setOpenConfirmationPassword(true);
    const selectedRows = JSON.parse(
      localStorage.getItem("selectedRows"),
      null,
      2
    );
    setRowsSelected(selectedRows);
  };
  const [ConfrimedPassword, setConfirmedPassword] = useState({
    password: "",
    errors: "",
  });
  const [alertOpenConfirmDeleteVoyage, setAlertOpenConfirmDeleteVoyage] =
    useState(false);
  const handleAlertOpenConfirmDeleteVoyage = () => {
    setAlertOpenConfirmDeleteVoyage(true);
  };
  const handleCloseAlertConfirmDeleteVoyage = () => {
    setAlertOpenConfirmDeleteVoyage(false);
  };

  {
    /* End Confirm password for delete Voyage */
  }

  // Ajout des états
  const [alertErrorImport, setAlertErrorImport] = useState(false);



  // Fonctions pour la gestion des alertes d'importation
  const handleOpenErrorAlertImport = () => {
    setAlertErrorImport(true);
  };

  const handleCloseErrorAlertImport = () => {
    setAlertErrorImport(false);
  };

  // Ajout des états pour les statistiques
  const [stats, setStats] = useState({
    totalVoyages: 0,
    voyagesEnCours: 0,
    voyagesTermines: 0,
    vehiculesEnSortie: 0,
    coutTotal: 0,
  });

  // Fonction pour calculer les statistiques
  const calculateStats = () => {
    const stats = {
      totalVoyages: Voyages.length,
      voyagesEnCours: Voyages.filter((v) => v.Statut === "En cours").length,
      voyagesTermines: Voyages.filter((v) => v.Statut === "Réalisé").length,
      vehiculesEnSortie: new Set(
        Voyages.filter((v) => v.Statut === "En cours").map((v) => v.ID_Vehicule)
      ).size,

      coutTotal: Voyages.reduce(
        (sum, v) => sum + (parseFloat(v.Coût_Total) || 0),
        0
      ),
    };
    setStats(stats);
  };

  const formatNumber = (num) => {
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
    if (num >= 1_000) return (num / 1_000).toFixed(1) + "k";
    return num.toString();
  };

  // Ajoutez ces états pour gérer les alertes
  const [alertOpenConfirmVoyage, setAlertOpenConfirmVoyage] = useState(false);
  const [alertOpenCancelVoyage, setAlertOpenCancelVoyage] = useState(false);

  // Ajoutez ces fonctions pour gérer les actions
  // const handleConfirmVoyage = async () => {
  //   const selectedRows = JSON.parse(localStorage.getItem("selectedRows") || "[]");

  //   if (selectedRows.length === 0) {
  //     setAlertOpenSelectedModifier(true);
  //     return;
  //   }

  //   // Vérifier si le voyage est déjà Réalisé
  //   if (selectedRows[0].Statut === "Réalisé") {
  //     setAlertVoyageDejaTermine(true);
  //     return;
  //   }

  //   // Vérifier si le voyage est annulé
  //   if (selectedRows[0].Statut === "Annulé") {
  //     setAlertVoyageDejaAnnule(true);
  //     return;
  //   }

  //   // Stocker les détails du voyage sélectionné et ouvrir le dialogue
  //   setSelectedVoyageDetails(selectedRows[0]);
  //   setConfirmDialogOpen(true);
  // };

  const handleCancelVoyage = async () => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);
    const selectedRows = JSON.parse(localStorage.getItem("selectedRows") || "[]");

    if (selectedRows.length === 0) {
      setAlertOpenSelectedModifier(true);
      return;
    }

    try {
      const promises = selectedRows.map((row) =>
        axios.put(
          `${API}/voyages/${row.ID_Voyage}`,
          { ...row, Statut: "Annulé" },
          {
            headers: { Authorization: `Bearer ${parsedAuthState.token}` },
          }
        )
      );

      await Promise.all(promises);
      setAlertOpenCancelVoyage(true);
      fetchVoyages(parsedAuthState.token);
    } catch (error) {
      console.error("Erreur lors de l'annulation du voyage:", error);
      setErrors({
        error: true,
        message: "Erreur lors de l'annulation du voyage",
      });
    }
  };


  /// Part de chargement des status des voyages

  const [openChangeStatuVoyage, setOpenChangeStatuVoyage] = useState(false);

  const handleOpenChangeStatuVoyage = () => {
    const selectedRows = JSON.parse(
      localStorage.getItem("selectedRows"),
      null,
      2
    );

    if (selectedRows.length === 0) {
      setAlertOpenSelectedModifier(true);
      return;
    } else {
      if (selectedRows[0].Statut === "Réalisé") {
        setAlertVoyageDejaTermine(true);
        return;
      }
      if (selectedRows[0].Statut === "Annulé") {
        setAlertVoyageDejaAnnule(true);
        return;
      }
      SetVoyageStatus(selectedRows);
      setModifierVoyage(selectedRows[0]);
      setOpenChangeStatuVoyage(true);
    }



  }

  const handleCloseChangeStatuVoyage = () => {
    setOpenChangeStatuVoyage(false);
  }





  // Ajoutez ces états
  const [annulationDialog, setAnnulationDialog] = useState(false);
  const [motifs, setMotifs] = useState([]);

  // Ajoutez cette fonction pour charger les motifs
  const fetchMotifs = async () => {
    try {
      const storedAuthState = sessionStorage.getItem("authLocalstorage");
      const parsedAuthState = JSON.parse(storedAuthState);

      const response = await axios.get(`${API}/motifs`, {
        headers: { Authorization: `Bearer ${parsedAuthState.token}` }
      });

      if (response.data.status) {
        setMotifs(response.data.data);
      }
    } catch (error) {
      console.error("Erreur lors du chargement des motifs:", error);
    }
  };


  const [selectedVoyageForAnnulation, setSelectedVoyageForAnnulation] = useState({});

  // 2. Modifier la fonction qui ouvre le dialogue d'annulation
  const handleOpenAnnulation = () => {
    const selectedRows = JSON.parse(localStorage.getItem("selectedRows") || "[]");

    if (selectedRows.length === 0) {
      setAlertOpenSelectedModifier(true);
      return;
    }

    // Vérifier si le voyage est déjà annulé
    if (selectedRows[0].Statut === "Annulé") {
      setAlertVoyageDejaAnnule(true);
      return;
    }

    // Vérifier si le voyage est déjà Réalisé
    if (selectedRows[0].Statut === "Réalisé") {
      setAlertVoyageDejaTermine(true);
      return;
    }

    // Ouvrir la boîte de dialogue de confirmation
    setConfirmAnnulationDialog(true);
  };

  // 3. Modifier la fonction d'annulation


  // 4. Modifier le composant AnnulationDialog
  const AnnulationDialog = () => {
    // États locaux pour le formulaire
    const [localMotif, setLocalMotif] = useState('');
    const [localCommentaire, setLocalCommentaire] = useState('');
    const [prix_total_voyage, setPrixTotalVoyage] = useState('');
    const [localPassword, setLocalPassword] = useState('');
    const [localError, setLocalError] = useState('');

    // Fonction de nettoyage
    const resetForm = () => {
      setLocalMotif('');
      setLocalCommentaire('');
      setPrixTotalVoyage('');
      setLocalPassword('');
      setLocalError('');
    };

    // Gestion de la fermeture
    const handleClose = () => {
      resetForm();
      setAnnulationDialog(false);
    };

    // Gestion de la soumission
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (!localMotif) {
        setLocalError('Veuillez sélectionner un motif');
        return;
      }
      if (!localPassword) {
        setLocalError('Veuillez saisir votre mot de passe');
        return;
      }

      try {
        const storedAuthState = sessionStorage.getItem("authLocalstorage");
        const parsedAuthState = JSON.parse(storedAuthState);

        // Vérifier le mot de passe
        const verifyResponse = await axios.post(
          `${API}/verify-password`,
          {
            email: parsedAuthState.user.email,
            password: localPassword
          }
        );

        if (!verifyResponse.data.success) {
          setLocalError('Mot de passe incorrect');
          return;
        }

        // Mise à jour uniquement du statut et des informations d'annulation
        const response = await axios.patch(  // Utiliser PATCH au lieu de PUT
          `${API}/voyages/${selectedVoyageForAnnulation.ID_Voyage}/annulation`,
          {
            Statut: "Annulé",
            Motif_Annulation: localMotif,
            Prix_Total_Voyage: prix_total_voyage,
            Commentaire_Annulation: localCommentaire
          },
          {
            headers: { Authorization: `Bearer ${parsedAuthState.token}` }
          }
        );

        if (response.data) {
          toast.success("Voyage annulé avec succès");
          handleClose();
          fetchVoyages(parsedAuthState.token);
          setAlertOpenAnnulation(true);
          logOperation({
            operation_type: "Annulation",
            entity_type: "Voyage",
            entity_id: parsedAuthState.user.id,
            description: localMotif + "-" + localCommentaire,
          });
        }

      } catch (error) {
        console.error("Erreur:", error);
        setLocalError(error.response?.data?.message || 'Une erreur est survenue');
      }
    };

    return (
      <Dialog
        open={annulationDialog}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            p: 2,
            position: 'relative'
          }
        }}
      >
        <form onSubmit={handleSubmit}>
          <DialogTitle>
            Annulation du voyage
            {selectedVoyageForAnnulation &&
              ` N° ${selectedVoyageForAnnulation.ID_Voyage}`
            }
          </DialogTitle>

          <DialogContent>
            <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
              <FormControl fullWidth error={Boolean(localError && !localMotif)}>
                <InputLabel>Motif d'annulation</InputLabel>
                <Select
                  required
                  value={localMotif}
                  onChange={(e) => {
                    setLocalMotif(e.target.value);
                    setLocalError('');
                  }}
                  label="Motif d'annulation"
                >
                  {motifs.map((motif) => (
                    <MenuItem key={motif.id} value={motif.libelle}>
                      {motif.libelle}
                    </MenuItem>
                  ))}
                </Select>

              </FormControl>

              <TextField
                fullWidth
                label="Total des frais (Prix du voyage)"
                type="number"
                value={prix_total_voyage}
                onChange={(e) => setPrixTotalVoyage(e.target.value)}
              />

              <TextField
                fullWidth
                label="Commentaire (optionnel)"
                multiline
                rows={3}
                value={localCommentaire}
                onChange={(e) => setLocalCommentaire(e.target.value)}
              />

              <TextField
                fullWidth
                label="Mot de passe"
                type="password"
                value={localPassword}
                onChange={(e) => {
                  setLocalPassword(e.target.value);
                  setLocalError('');
                }}
                error={Boolean(localError)}
                helperText={localError}
              />
            </Box>
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              startIcon={<CloseIcon />}
            >
              Annuler
            </Button>
            <Button
              variant="contained"
              type="submit"
              sx={{ bgcolor: '#1D3E62' }}
              startIcon={<CheckCircleIcon />}
            >
              Confirmer
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  };

  const MenuButton = () => {
    // Ajouter cette ligne au début du composant MenuButton
    const [selectedRows, setSelectedRows] = useState(JSON.parse(localStorage.getItem("selectedRows") || "[]"));
    // Mettre à jour selectedRows quand le localStorage change
    useEffect(() => {
      const handleStorageChange = () => {
        setSelectedRows(JSON.parse(localStorage.getItem("selectedRows") || "[]"));

      };

      window.addEventListener('storage', handleStorageChange);
      return () => {
        window.removeEventListener('storage', handleStorageChange);
      };
    }, []);

    return (
      <Box
        sx={{
          height: "100%",
          padding: "24px",
          borderRadius: "20px",
          backgroundColor: "#f8fafc",
        }}
      >
        {/* Header Section */}
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '20px',
          paddingBottom: '16px',
          borderBottom: '1px solid #f3f4f6'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Box sx={{
              width: '40px',
              height: '40px',
              borderRadius: '6px',
              backgroundColor: '#3b82f6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <LocalShippingIcon style={{ color: 'white', fontSize: '20px' }} />
            </Box>
            <Typography variant="h4" sx={{
              fontWeight: 600,
              color: '#1f2937',
              fontSize: { xs: '1.25rem', md: '1.5rem' },
              letterSpacing: '-0.025em'
            }}>
              Gestion des Voyages
            </Typography>
          </Box>

          <Typography variant="body2" sx={{
            color: '#6b7280',
            fontSize: '14px',
            fontWeight: 500,
            backgroundColor: '#f9fafb',
            padding: '6px 12px',
            borderRadius: '6px',
            border: '1px solid #e5e7eb'
          }}>
            {Voyages.length} voyage{Voyages.length !== 1 ? 's' : ''}
          </Typography>
        </Box>

        <Box sx={{ mb: 2 }}>
          <SeparatorBreadcrumbs path="Transport" items={["Voyage"]} />
        </Box>

        {/* Stats Cards with Modern Design */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {/* Total Voyages Card */}
          <Grid item xs={12} sm={6} md={2.4}>
            <Card
              sx={{
                p: 2,
                height: "140px",
                borderRadius: "16px",
                background: "#fff",
                position: "relative",
                overflow: "hidden",
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "translateY(-5px)",
                },
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
              }}
            >
              <Box sx={{ position: "relative", zIndex: 1 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#64748b", mb: 1 }}
                >
                  Total Voyages
                </Typography>
                <Typography
                  variant="h4"
                  sx={{ color: "#1e293b", fontWeight: 700 }}
                >
                  {Voyages.length}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 1,
                  }}
                >
                  <TrendingUpIcon
                    sx={{ color: "#10b981", fontSize: 16, mr: 0.5 }}
                  />
                  <Typography variant="caption" sx={{ color: "#10b981" }}>
                    +
                    {(
                      ((Voyages.length -
                        Voyages.filter((v) => v.Statut === "Réalisé").length) /
                        Voyages.length) *
                      100
                    ).toFixed(1)}
                    %
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Grid>

          {/* Voyages en Cours Card */}
          <Grid item xs={12} sm={6} md={2.4}>
            <Card
              sx={{
                p: 2,
                height: "140px",
                borderRadius: "16px",
                background: "#fff",
                position: "relative",
                overflow: "hidden",
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "translateY(-5px)",
                },
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
              }}
            >
              <Box sx={{ position: "relative", zIndex: 1 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#64748b", mb: 1 }}
                >
                  Voyages en Cours
                </Typography>
                <Typography
                  variant="h4"
                  sx={{ color: "#1e293b", fontWeight: 700 }}
                >
                  {Voyages.filter((v) => v.Statut === "En cours").length}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 1,
                  }}
                >
                  <DirectionsCarIcon
                    sx={{ color: "#6366f1", fontSize: 16, mr: 0.5 }}
                  />
                  <Typography variant="caption" sx={{ color: "#6366f1" }}>
                    Actifs
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Grid>

          {/* Voyages Réalisés Card */}
          <Grid item xs={12} sm={6} md={2.4}>
            <Card
              sx={{
                p: 2,
                height: "140px",
                borderRadius: "16px",
                background: "#fff",
                position: "relative",
                overflow: "hidden",
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "translateY(-5px)",
                },
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
              }}
            >
              <Box sx={{ position: "relative", zIndex: 1 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#64748b", mb: 1 }}
                >
                  Voyages Réalisés
                </Typography>
                <Typography
                  variant="h4"
                  sx={{ color: "#1e293b", fontWeight: 700 }}
                >
                  {Voyages.filter((v) => v.Statut === "Réalisé").length}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 1,
                  }}
                >
                  <CheckCircleIcon
                    sx={{ color: "#10b981", fontSize: 16, mr: 0.5 }}
                  />
                  <Typography variant="caption" sx={{ color: "#10b981" }}>
                    Complétés
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Grid>

          {/* Véhicules en Sortie Card */}
          <Grid item xs={12} sm={6} md={2.4}>
            <Card
              sx={{
                p: 2,
                height: "140px",
                borderRadius: "16px",
                background: "#fff",
                position: "relative",
                overflow: "hidden",
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "translateY(-5px)",
                },
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
              }}
            >
              <Box sx={{ position: "relative", zIndex: 1 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#64748b", mb: 1 }}
                >
                  Véhicules en Sortie
                </Typography>
                <Typography
                  variant="h4"
                  sx={{ color: "#1e293b", fontWeight: 700 }}
                >
                  {
                    new Set(
                      Voyages.filter((v) => v.Statut === "En cours").map(
                        (v) => v.ID_Vehicule
                      )
                    ).size
                  }
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 1,
                  }}
                >
                  <LocalShippingIcon
                    sx={{ color: "#f59e0b", fontSize: 16, mr: 0.5 }}
                  />
                  <Typography variant="caption" sx={{ color: "#f59e0b" }}>
                    En route
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Grid>

          {/* Coût Total Card */}
          <Grid item xs={12} sm={6} md={2.4}>
            {["user-facture", "admin", "super-admin"].includes(role) && <Card
              sx={{
                p: 2,
                height: "140px",
                borderRadius: "16px",
                background: "#fff",
                position: "relative",
                overflow: "hidden",
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "translateY(-5px)",
                },
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
              }}
            >
              <Box sx={{ position: "relative", zIndex: 1 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#64748b", mb: 1 }}
                >
                  Coût Total
                </Typography>
                <Typography
                  variant="h4"
                  sx={{ color: "#1e293b", fontWeight: 700 }}
                >
                  {formatNumber(
                    Voyages.reduce(
                      (sum, v) => sum + (parseFloat(v.prix_total_voyage) || 0),
                      0
                    )
                  )}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 1,
                  }}
                >
                  <PaidIcon sx={{ color: "#14b8a6", fontSize: 16, mr: 0.5 }} />
                  <Typography variant="caption" sx={{ color: "#14b8a6" }}>
                    Dépenses totales
                  </Typography>
                </Box>
              </Box>
            </Card>}
          </Grid>
        </Grid>

        {/* Action Buttons with Modern Design */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            mb: 0,
            p: 3,
            borderRadius: "16px",
            bgcolor: "#fff",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
            justifyContent: "space-between",
          }}
        >
          {/* Premier groupe de boutons (à gauche) */}
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            {isAllowedAjouterVoyage == 1 && (
              <ButtonAttribute
                Label="Nouveau Voyage"
                action={handleOpen}
                Bgcolor="#6366f1"
                color="white"
                bgColorHover="#4F46E5"
                startIcon={<FontAwesomeIcon icon={faPlus} />}
                width="auto"
                height="45px"

              />
            )}

            {isAllowedModifierVoyage == 1 && (
              <ButtonAttribute
                Label="Modifier le Voyage"
                action={handleOpenModifier}
                Bgcolor="#FFC107"
                color="white"
                bgColorHover="#E0A800"
                width="200px"
                height="45px"
                startIcon={<FontAwesomeIcon icon={faPen} />}
                sx={{
                  borderRadius: "10px",
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 600,
                  boxShadow: "0 4px 6px rgba(255, 193, 7, 0.2)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 6px 12px rgba(255, 193, 7, 0.3)",
                  },
                }}
              />
            )}

            {isAllowedSupprimerVoyage == 1 && (
              <ButtonAttribute
                Label="Supprimer Voyage"
                action={handleOpenDeleteVoyage}
                Bgcolor="#DC3545"
                color="white"
                bgColorHover="#C82333"
                width="200px"
                height="45px"
                startIcon={<FontAwesomeIcon icon={faTrash} />}
                sx={{
                  borderRadius: "10px",
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 600,
                  boxShadow: "0 4px 6px rgba(220, 53, 69, 0.2)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 6px 12px rgba(220, 53, 69, 0.3)",
                  },
                }}
              />
            )}
            {isAllowedConfirmerVoyage == 1 && (
              <ButtonAttribute
                Label="Confirmer Voyage"
                action={handleConfirmVoyage}
                Bgcolor="#FFFFFF"
                color="#4CAF50"
                bgColorHover="#E8F5E9"
                width="220px"
                height="45px"

                startIcon={
                  <Stack direction="row" spacing={1} alignItems="center">
                    <VerifiedIcon sx={{ color: '#4CAF50' }} />
                    <LocalShippingIcon fontSize="small" sx={{ color: '#4CAF50' }} />
                  </Stack>
                }
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 600,
                  border: '2px solid #4CAF50',
                  boxShadow: '0 2px 8px rgba(76, 175, 80, 0.15)',
                  transition: 'all 0.3s ease',

                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 12px rgba(76, 175, 80, 0.25)',
                    color: '#388E3C',
                    borderColor: '#388E3C'
                  },
                }}
              />
            )}

            {isAllowedAnnulerVoyage == 1 &&
              <ButtonAttribute
                Label="Annuler Voyage"
                action={handleOpenAnnulation}
                Bgcolor="#FFFFFF"
                color="#F44336"
                bgColorHover="#FFF0F0"
                width="220px"
                height="45px"

                startIcon={
                  <Stack direction="row" spacing={1} alignItems="center">
                    <CancelIcon sx={{ color: '#F44336' }} />
                    <LocalShippingIcon fontSize="small" sx={{ color: '#F44336' }} />
                  </Stack>
                }
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 600,
                  border: '2px solid #F44336',
                  boxShadow: '0 2px 8px rgba(244, 67, 54, 0.15)',
                  transition: 'all 0.3s ease',

                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 12px rgba(244, 67, 54, 0.25)',
                    color: '#D32F2F',
                    borderColor: '#D32F2F'
                  },
                }}
              />}
            {isAllowedModifierVoyage == 1 && isAllowedConfirmerVoyage == 1 &&
              <ButtonAttribute
                Label="Changer Statut Voyage"
                action={handleOpenChangeStatuVoyage}
                Bgcolor="#4CAF50"   // Green background for normal state
                color="#FFFFFF"     // White text color
                bgColorHover="#388E3C"  // Darker green background on hover
                width="250px"
                height="45px"

                startIcon={
                  <Stack direction="row" spacing={1} alignItems="center">
                    <FontAwesomeIcon icon={faRetweet} />

                  </Stack>
                }
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 600,
                  border: '2px solid #4CAF50',  // Green border for normal state
                  boxShadow: '0 2px 8px rgba(76, 175, 80, 0.15)',  // Light green shadow
                  transition: 'all 0.3s ease',
                  opacity: (selectedRows?.length > 0 && (selectedRows[0].Statut === "Réalisé" || selectedRows[0].Statut === "Annulé")) ? 0.5 : 1,
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 12px rgba(76, 175, 80, 0.25)',  // Darker green shadow on hover
                    color: '#FFFFFF',  // White text on hover
                    borderColor: '#388E3C',  // Darker green border on hover
                  },
                }}
              />
            }
          </Box>


          {/* Deuxième groupe de boutons (à droite) */}
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            {isAllowedImporterVoyage == 1 && (
              <ButtonAttribute
                Label="Importer Voyage"
                action={handleOpenImportationVoyage}
                Bgcolor="#6F42C1"
                color="white"
                bgColorHover="#563D7C"
                type="button"
                height="45px"
                startIcon={<FontAwesomeIcon icon={faFileImport} />}
              />
            )}

            {isAllowedExporterVoyage == 1 && (
              <ButtonAttribute
                Label="Exporter Voyages"
                action={handleOpenExtrationVoyage}
                Bgcolor="#17A2B8"
                color="white"
                bgColorHover="#117A8B"
                type="button"
                height="45px"
                startIcon={<FontAwesomeIcon icon={faFileExport} />}
              />
            )}
          </Box>
        </Box>

        {/* Ajoutez ces alertes */}
        <AlertBar
          open={alertOpenConfirmVoyage}
          onClose={() => setAlertOpenConfirmVoyage(false)}
          textContent="Le(s) voyage(s) ont été confirmé(s) avec succès"
          severity="success"
        />

        <AlertBar
          open={alertOpenCancelVoyage}
          onClose={() => setAlertOpenCancelVoyage(false)}
          textContent="Le(s) voyage(s) ont été annulé(s)"
          severity="warning"
        />

        {/* Ajoutez le dialogue d'annulation */}
        <AnnulationDialog />
      </Box>
    );
  };

  const columns = [
    {
      accessorKey: "ID_Voyage",
      header: "ID Voyage",
      size: 150,
    },

    {
      accessorKey: "Client_facturation",
      header: "Client Facturation",
      size: 150,
      Cell: ({ cell }) => {
        const client = clients.find(c => c.ID_Client == cell.getValue());
        return client ? client.Nom : "N/A";
      }
    },

    {
      accessorKey: "ID_Vehicule",
      header: "Véhicule",
      size: 150,
      Cell: ({ cell }) => {
        const vehicule = vehicules.find(v => v.id == cell.getValue());
        return vehicule ? vehicule.matricule : cell.getValue();
      }
    },

    { accessorKey: "Date_chargement", header: "Date Chargement", size: 150 },
    { accessorKey: "Date_déchargement", header: "Date Déchargement", size: 150 },

    // -----------------------------------------------------------
    // 🔥 SHOW ONLY IF ROLE IS: user-facture, admin, super-admin
    // -----------------------------------------------------------
    ...(["user-facture", "admin", "super-admin"].includes(role)
      ? [
        {
          accessorKey: "Coût_Total",
          header: "Coût Total",
          size: 150,
        },
        {
          accessorKey: "prix_total_voyage",
          header: "Prix Total Voyage",
          size: 150,
        },
      ]
      : []
    ),
    // -----------------------------------------------------------

    { accessorKey: "Expediteur", header: "Expéditeur", size: 200 },
    { accessorKey: "Destinataire", header: "Destinataire", size: 200 },

    { accessorKey: "Zone_déchargement", header: "Zone Déchargement", size: 200 },
    { accessorKey: "Statut", header: "Statut", size: 150 },

    { accessorKey: "Motif_Annulation", header: "Motif Annulation", size: 200 },
    { accessorKey: "Commentaire_Annulation", header: "Commentaire Annulation", size: 200 },

    { accessorKey: "Nombre_palettes", header: "Nombre de Palettes", size: 150 },

    {
      accessorKey: "Type_de_moyen",
      header: "Type de Moyen",
      size: 200,
      Cell: ({ cell }) => {
        switch (cell.getValue()) {
          case "taxi": return "Taxi";
          case "T3_5": return "Camion lourd 3/5 T";
          case "T7": return "Camion léger 7 T";
          case "T14": return "Camion lourd 14 T";
          case "T18": return "Camion lourd 18 T";
          case "Tracteur": return "Tracteur";
          case "semi_remorque": return "Semi remorque";
          default: return cell.getValue();
        }
      }
    },

    { accessorKey: "Type_Voyage", header: "Type de Voyage", size: 200 },

    {
      accessorKey: "Fournisseur",
      header: "Fournisseur",
      size: 200,
      Cell: ({ cell }) => {
        const fournisseur = fournisseurs.find(f => f.id == cell.getValue());
        return fournisseur ? fournisseur.Matricule : "N/A";
      }
    },

    { accessorKey: "N_CMR", header: "N° CMR", size: 150 },
    { accessorKey: "N_CMR_RT", header: "N° CMR RT", size: 150 },
    { accessorKey: "N_DUM_RT", header: "N° DUM RT", size: 150 },
    { accessorKey: "N_DUM", header: "N° DUM", size: 150 },

    {
      accessorKey: "Scellés_Douane",
      header: "Scellés Douane",
      size: 200,
      Cell: ({ cell }) => {
        const value = cell.getValue();

        if (!value) return "N/A";

        // Split ids (example: "135/136/137")
        const ids = String(value).split("/");

        const numeros = ids
          .map((id) => {
            const found = scelles.find(
              (s) => String(s.id) === String(id)
            );
            return found?.numero_scelle;
          })
          .filter(Boolean);

        return numeros.length > 0
          ? numeros.join(" / ")
          : "N/A";
      },
    },

    {
      accessorKey: "BL_Number",
      header: "BL Number",
      size: 150,
      Cell: ({ cell }) => (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <DescriptionIcon />
          {cell.getValue() || "-"}
        </Box>
      ),
    },

    { accessorKey: "Immobilisation", header: "Immobilisation", size: 200 },
    { accessorKey: "N_jours", header: "Nombre de Jours", size: 150 },
    { accessorKey: "Prix_Immobilisation", header: "Prix Immobilisation", size: 200 },
    { accessorKey: "Prestation", header: "Prestation", size: 200 },
    { accessorKey: "Prix_Prestation", header: "Prix Prestation", size: 200 },
    { accessorKey: "Type_de_prestation", header: "Type de Prestation", size: 200 },

    {
      accessorKey: "est_facture",
      header: "Est Facturé",
      size: 150,
      Cell: ({ cell }) => (cell.getValue() == 1 ? "✅ Oui" : "❌ Non"),
    },

    { accessorKey: "ID_Tarification", header: "Tarification", size: 200 },
  ];




  // Function to get the 'allowed' value for a specific action
  const getPermission = (permissions, section, actionName) => {
    const sectionPermissions = permissions.find(
      (perm) => perm.name === section
    );
    if (!sectionPermissions) return 0;

    const action = sectionPermissions.actions.find(
      (act) => act.name === actionName
    );
    return action.allowed;
  };
  const { TokenExp, logout } = useAuth();
  const [token, setToken] = useState(null);


  useEffect(() => {
    // Zoom UI globally


    // Cleanup any previously stored UI state
    localStorage.removeItem('selectedRows');

    // Get auth state from sessionStorage
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = storedAuthState ? JSON.parse(storedAuthState) : null;


    if (parsedAuthState?.token) {
      // Check token expiration
      const expiresAt = new Date(parsedAuthState.expiresAt);
      if (expiresAt <= new Date()) {
        // alert('⏰ Votre session a expiré. Veuillez vous reconnecter.');
        logout();
        return;
      }

      setPermissions(parsedAuthState.permissions || []);
      setRole(parsedAuthState.user?.role?.name || '');
      fetchVoyages(parsedAuthState.token);
      GetClients();
      GetChauffeurs();
      GetVehicules();
      calculateStats();
      GetVillesTarification(parsedAuthState.token);
      fetchMotifs();
      GetFournisseurs(parsedAuthState.token);
      GetScelles(parsedAuthState.token);
      GetListDUM(parsedAuthState.token);
      SetVoyageStatus([]);
      // Optional: reset errors after delay
      setTimeout(() => {
        setErrorsClient({ error: false, message: "" });
        setErrorsVehicule({ error: false, message: "" });
        setErrors({ error: false, message: "" });
      }, 5000);
    } else {
      // Not authenticated
      logout();
    }
  }, []);
  // Calculer le prix total for new voyage 
  useEffect(() => {
    const prixPrestation = parseFloat(newVoyage.Prix_Prestation) || 0;
    const prixImmobilisation = parseFloat(newVoyage.Prix_Immobilisation) || 0;
    const coutTotal = parseFloat(newVoyage.Coût_Total) || 0;

    const total = prixPrestation + prixImmobilisation + coutTotal;

    setNewVoyage((prev) => ({
      ...prev,
      prix_total_voyage: total.toFixed(2),
    }));
  }, [newVoyage.Prix_Prestation, newVoyage.Prix_Immobilisation, newVoyage.Coût_Total]);


  //  calculer le prix total for modifier voyage
  useEffect(() => {
    const prixPrestation = parseFloat(modifierVoyage.Prix_Prestation) || 0;
    const prixImmobilisation = parseFloat(modifierVoyage.Prix_Immobilisation) || 0;
    const coutTotal = parseFloat(modifierVoyage.Coût_Total) || 0;

    const total = prixPrestation + prixImmobilisation + coutTotal;

    setModifierVoyage((prev) => ({
      ...prev,
      prix_total_voyage: total.toFixed(2),
    }));
  }, [modifierVoyage.Prix_Prestation, modifierVoyage.Prix_Immobilisation, modifierVoyage.Coût_Total]);


  // Function to fetch Voyages
  const fetchVoyages = async (token) => {
    try {
      const response = await axios.get(`${API}/voyages`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setVoyages(response.data.data);
    } catch (error) {
      console.error("Error fetching Voyages:", error);
      setErrors({ error: true, message: "Failed to fetch Voyages" });
    }
  };

  {
    /* begin modal ajouter Voyage  */
  }

  {
    /* begin Functions for Dropdown data   */
  }


  const [clients, setClients] = useState([]);
  const [chauffeurs, setChauffeurs] = useState([]);
  const [vehicules, setVehicules] = useState([]);
  const [villesTarification, setVillesTarification] = useState([]);
  const [VillesTarificationByClient, setVillesTarificationByClient] = useState([]);
  const [villeSelected, setVilleSelected] = useState([]);
  const [destinationType, setDestinationType] = useState([]);
  const [destinationTypeModifier, setDestinationTypeModifier] = useState([]);
  const [fournisseurs, setFournisseurs] = useState([]);
  const [scelles, setScelles] = useState([]);
  const [listDUM, setListDUM] = useState([]);
  const GetClients = async () => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);
    try {
      const response = await axios.get(`${API}/clients`, {
        headers: { Authorization: `Bearer ${parsedAuthState.token}` },
      });
      setClients(response.data.data);

    } catch (error) {
      console.error("Error fetching clients:", error);
      setErrorsClient({ error: true, message: "Failed to fetch clients" });
    }
  };
  const GetChauffeurs = async () => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);
    try {
      const response = await axios.get(`${API}/chauffeurs`, {
        headers: { Authorization: `Bearer ${parsedAuthState.token}` },
      });
      setChauffeurs(response.data.data);

    } catch (error) {
      console.error("Error fetching Voyages:", error);
      setErrors({ error: true, message: "Failed to fetch Voyages" });
    }
  };
  const GetVehicules = async () => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);
    try {
      const response = await axios.get(`${API}/vehicules`, {
        headers: { Authorization: `Bearer ${parsedAuthState.token}` },
      });
      setVehicules(response.data.data);

    } catch (error) {
      console.error("Error fetching Voyages:", error);
      setErrors({ error: true, message: "Failed to fetch Voyages" });
    }
  };
  const GetVillesTarification = async (token) => {
    await axios
      .get(`${API}/tarifications`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setVillesTarification(response.data.data);

      })
      .catch((error) => {
        console.error(
          "Erreur lors de la récupération des villes de départ",
          error
        );
      });
  };

  const GetFournisseurs = async (token) => {
    await axios
      .get(`${API}/fournisseurs`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setFournisseurs(response.data.data);

      })
      .catch((error) => {
        console.error(
          "Erreur lors de la récupération des villes de départ",
          error
        );
      });
  }

  const GetScelles = async (token) => {
    await axios
      .get(`${API}/scelles`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setScelles(response.data.data);

      })
      .catch((error) => {
        console.error(
          "Erreur lors de la récupération des villes de départ",
          error
        );
      });
  }

  const GetListDUM = async (token) => {
    await axios
      .get(`${API}/declarations`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setListDUM(response.data.data);

      })
      .catch((error) => {
        console.error(
          " Erreur lors de la récupération des villes de départ ",
          error
        );
      });
  }



  const parseIdsFromAny = (v) => {
    if (Array.isArray(v)) return v.map(Number);
    if (typeof v === 'string')
      return v.split(/[\/,;,|\s]+/).filter(Boolean).map(Number); // supports "2/5/8" or "2,5,8"
    if (v == null) return [];
    return [Number(v)];
  };

  // 2) normalize value coming from API (GET)
  // Example: run this after you load the voyage from backend
  const selectedIds = React.useMemo(
    () => parseIdsFromAny(modifierVoyage.Scellés_Douane),
    [modifierVoyage.Scellés_Douane]
  );

  // 3) keep options = not used OR already selected (so edit doesn't lose chips)
  const scellesOptions = React.useMemo(() => {
    const selectedSet = new Set(selectedIds);
    return scelles.filter((sc) => sc.utilise === 0 || selectedSet.has(sc.id));
  }, [scelles, selectedIds]);
  {
    /*  end Functions for Dropdown data   */
  }

  {
    /*  begin Drawer client   */
  }
  const [DrawerClientOpen, setDrawerClientOpen] = useState(false);
  const [newClient, setNewClient] = useState({
    Nom: '',
    Adresse: '',
    Email: '',
    Contact: '',
    Type_Client: '',
    Raison_sociale: '',     // Added Raison_sociale
    Forme_juridique: '',    // Added Forme_juridique
    Code_client: '',        // Added Code_client
    Sites: '',              // Added Sites
    IF: '',                 // Added IF
    ICE: '',                // Added ICE
    taux_de_TVA: '',        // Added taux_de_TVA
    Mode_de_reglement: '',  // Added Mode_de_reglement
    Echéance_de_reglement: "",
    Activité: '',           // Added Activité
  });
  const [errorsClient, setErrorsClient] = useState({
    error: false,
    message: "",
  });
  const [alertOpenNouveauClient, setAlertOpenNouveauClient] = useState(false);
  const handleCloseAlertNouveauClient = () => {
    setAlertOpenNouveauClient(false);
  };
  const handleOpenAlertNouveauClient = () => {
    setAlertOpenNouveauClient(true);
  };
  const handleOpenDrawerClient = () => {
    setDrawerClientOpen(true);
  };
  const handleCloseDrawerClient = () => {
    setDrawerClientOpen(false); // Close the drawer
  };
  {
    /* end drawer for new client  */
  }

  {
    /* begin Drawer for new vehicle */
  }

  const [DrawerVehiculeOpen, setDrawerVehiculeOpen] = useState(false);
  const [newVehicule, setNewVehicule] = useState({
    code_vehicule: "",
    marque: "",
    matricule: "",
    type_moyen: "",                  // ex: "taxi" | "T3_5" | "T7" | "T14" | "T18" | "semi_remorque" | "Tracteur"
    numero_chassis: "",
    premiere_mise_en_circulation: "",// "YYYY-MM-DD"
    premiere_mise_au_maroc: "",      // "YYYY-MM-DD"
    ptac: "",                        // number as string
    poids_vide: "",                  // number as string
    date_acquisition: "",            // "YYYY-MM-DD"
    type_acquisition: "",            // "leasing" | "comptant"
    valeur_achat: "",                // number as string
    date_premier_prelevement: "",    // "YYYY-MM-DD" (leasing)
    date_dernier_prelevement: "",    // "YYYY-MM-DD" (leasing)
    nombre_prelevements: "",         // int as string (leasing)
    montant_loyer_ttc: "",           // number as string (leasing)
    carburant: "",
    numero_police_assurance: "",
    date_expiration_assurance: "",   // "YYYY-MM-DD"
    gps_installe: 0,                 // 0|1
    statut: "",                 // "actif" | "inactif" | "vendu" | "endommagé"
    id_chauffeur: ""              // required
  });


  const [errorsVehicule, setErrorsVehicule] = useState({
    error: false,
    message: "",
  });
  const [alertOpenNouveauVehicule, setAlertOpenNouveauVehicule] =
    useState(false);
  const handleCloseAlertNouveauVehicule = () => {
    setAlertOpenNouveauVehicule(false);
  };
  const handleOpenAlertNouveauVehicule = () => {
    setAlertOpenNouveauVehicule(true);
  };
  const handleOpenDrawerVehicule = () => {
    setDrawerVehiculeOpen(true);
  };
  const handleCloseDrawerVehicule = () => {
    setDrawerVehiculeOpen(false); // Close the drawer
  };

  // state must include code_vehicule
  // const [newVehicule, setNewVehicule] = useState({ code_vehicule:"", ... });



  const [isSubmittingVehicule, setIsSubmittingVehicule] = useState(false);

  const str = (v) => (v == null ? "" : String(v).trim());
  const ymdOrNull = (v) => (str(v) ? str(v).slice(0, 10) : null);
  const handleAjouterVehicule = async () => {
    const token = JSON.parse(sessionStorage.getItem("authLocalstorage") || "{}")?.token;

    // required (aligné backend)
    const missing = [];
    if (!str(newVehicule.code_vehicule)) missing.push("Code véhicule");
    if (!str(newVehicule.marque)) missing.push("Marque");
    if (!str(newVehicule.matricule)) missing.push("Matricule");
    if (!str(newVehicule.id_chauffeur)) missing.push("Chauffeur");

    // leasing -> champs requis
    const isLeasing = str(newVehicule.type_acquisition) === "leasing";
    if (isLeasing) {
      if (!str(newVehicule.date_premier_prelevement)) missing.push("Date premier prélèvement");
      if (!str(newVehicule.date_dernier_prelevement)) missing.push("Date dernier prélèvement");
      if (!str(newVehicule.montant_loyer_ttc)) missing.push("Montant loyer TTC");
    }

    if (missing.length) {
      setErrorsVehicule({ error: true, message: `Champs requis: ${missing.join(", ")}` });
      return;
    }

    if (isSubmittingVehicule) return;
    setIsSubmittingVehicule(true);
    setErrorsVehicule({ error: false, message: "" });

    const payload = {
      code_vehicule: str(newVehicule.code_vehicule),
      marque: str(newVehicule.marque),
      matricule: str(newVehicule.matricule),
      type_moyen: str(newVehicule.type_moyen) || null,
      numero_chassis: str(newVehicule.numero_chassis) || null,
      premiere_mise_en_circulation: ymdOrNull(newVehicule.premiere_mise_en_circulation),
      premiere_mise_au_maroc: ymdOrNull(newVehicule.premiere_mise_au_maroc),
      ptac: numOrNull(newVehicule.ptac),
      poids_vide: numOrNull(newVehicule.poids_vide),
      date_acquisition: ymdOrNull(newVehicule.date_acquisition),
      type_acquisition: str(newVehicule.type_acquisition) || null,
      valeur_achat: numOrNull(newVehicule.valeur_achat),
      date_premier_prelevement: isLeasing ? ymdOrNull(newVehicule.date_premier_prelevement) : null,
      date_dernier_prelevement: isLeasing ? ymdOrNull(newVehicule.date_dernier_prelevement) : null,
      nombre_prelevements: isLeasing ? intOrNull(newVehicule.nombre_prelevements) : null,
      montant_loyer_ttc: isLeasing ? numOrNull(newVehicule.montant_loyer_ttc) : null,
      carburant: str(newVehicule.carburant) || null,
      numero_police_assurance: str(newVehicule.numero_police_assurance) || null,
      date_expiration_assurance: ymdOrNull(newVehicule.date_expiration_assurance),
      gps_installe: newVehicule.gps_installe ? 1 : 0,
      statut: str(newVehicule.statut) || "actif",
      id_chauffeur: intOrNull(newVehicule.id_chauffeur),
    };

    try {
      await axios.post(`${API}/vehicules`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      handleClose();
      setAlertOpen(true);
      await GetVehicules();
      handleCloseDrawerVehicule();

      setNewVehicule({
        code_vehicule: "",
        id_chauffeur: "",
        marque: "",
        matricule: "",
        type_moyen: "",
        numero_chassis: "",
        premiere_mise_en_circulation: "",
        premiere_mise_au_maroc: "",
        ptac: "",
        poids_vide: "",
        date_acquisition: "",
        type_acquisition: "",
        valeur_achat: "",
        date_premier_prelevement: "",
        date_dernier_prelevement: "",
        nombre_prelevements: "",
        montant_loyer_ttc: "",
        carburant: "",
        numero_police_assurance: "",
        date_expiration_assurance: "",
        gps_installe: false,
        statut: "actif",
      });

      const u = JSON.parse(sessionStorage.getItem("authLocalstorage") || "{}")?.user;
      logOperation({
        operation_type: "CREATION",
        entity_type: "Vehicule",
        entity_id: u?.id,
        description: "Ajout d'un véhicule",
      });
    } catch (error) {
      const status = error?.response?.status;
      const svr = error?.response?.data;
      const msg =
        svr?.message ||
        (status === 409 ? "Code véhicule ou matricule déjà utilisé" :
          status === 422 ? "Erreur de validation" :
            "Échec lors de l'ajout du véhicule");
      setErrorsVehicule({ error: true, message: msg });
      console.error("Erreur ajout véhicule:", error);
    } finally {
      setIsSubmittingVehicule(false);
    }
  };


  /* end drawer for new vehicle */

  /* begin Drawer for new fournisseur */

  const [DrawerFournisseurOpen, setDrawerFournisseurOpen] = useState(false);
  const [newFournisseur, setNewFournisseur] = useState({
    Nom: "",
    Contact: "",
    Cout_Achat: 0,
    Matricule: "",
  })
  const [errorsFournisseur, setErrorsFournisseur] = useState({
    error: false,
    message: "",
  })
  const handleOpenDrawerFournisseur = () => {
    setDrawerFournisseurOpen(true);
  };
  const handleCloseDrawerFournisseur = () => {
    setDrawerFournisseurOpen(false); // Close the drawer
  };

  const handleAjouterFournisseur = () => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);


    if (
      newFournisseur.Nom === "" ||
      newFournisseur.Contact === "" ||
      newFournisseur.Cout_Achat === "" ||
      newFournisseur.Matricule === ""
    ) {
      setErrorsFournisseur({ error: true, message: "Ce champ est obligatoire" });
      return;
    }
    else {
      axios
        .post(
          `${API}/fournisseurs`,
          {
            Nom: newFournisseur.Nom,
            Contact: newFournisseur.Contact,
            Cout_Achat: newFournisseur.Cout_Achat,
            Matricule: newFournisseur.Matricule
          },
          {
            headers: { Authorization: `Bearer ${parsedAuthState.token}` },
          }
        )
        .then((response) => {

          handleCloseDrawerFournisseur();
          GetFournisseurs(parsedAuthState.token);
          setNewFournisseur({
            Nom: "",
            Contact: "",
            Cout_Achat: 0,
            Matricule: "",
          });
          logOperation({
            operation_type: "CREATE",
            entity_type: "Fournisseur",
            entity_id: parsedAuthState.user.id,
            description: "Ajout d'un fournisseur",
          });
        })
        .catch((error) => {
          console.error("Erreur lors de l'ajout du fournisseur", error);
          setErrorsFournisseur({ error: true, message: "Erreur lors de l'ajout du fournisseur" });
        })
    }
  }
  /* begin Drawer for new Chauffeur */

  {/* begin Drawer for new Linges de voyages   */ }
  const [LingesVoyagesOpen, setLingesVoyagesOpen] = useState(false);
  const [LingesVoyages, setLignesVoyages] = useState([]);
  const [alertOpenModifierLingesVoyages, setAlertOpenModifierLingesVoyages] = useState(false)

  const handleAlertOpenModifierLingesVoyages = () => {
    setAlertOpenModifierLingesVoyages(true);
  }

  const handleAlertCloseModifierLingesVoyages = () => {
    setAlertOpenModifierLingesVoyages(false);
  }

  const [newLingesVoyages, setNewLingesVoyages] = useState({
    voyage_principal_id: "",
    expediteur: "",
    destinataire: "",
    statut: "Réserver",
    commentaires: "",
  });
  const [ModifierLingesVoyage, setModifierLingesVoyage] = useState({
    id: '',
    voyage_principal_id: "",
    expediteur: "",
    destinataire: "",
    statut: "",
    commentaires: "",
  });
  const handleRowClick = (voyage) => {
    setModifierLingesVoyage({
      id: voyage.id,
      voyage_principal_id: voyage.voyage_principal_id,
      expediteur: voyage.expediteur,
      destinataire: voyage.destinataire,
      statut: voyage.statut,
      commentaires: voyage.commentaires,
    });
  };

  const handleModifierLigneVoyage = () => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);

    axios.put(`${API}/lignes-voyage/${ModifierLingesVoyage.id}`,
      ModifierLingesVoyage,
      {
        headers: { Authorization: `Bearer ${parsedAuthState.token}` },
      }
    )
      .then((res) => {
        handleAlertOpenModifierLingesVoyages();
        logOperation({
          operation_type: "UPDATE",
          entity_type: "Ligne de voyage",
          entity_id: parsedAuthState.user.id,
          description: "Modifier des informations de la ligne de voyage",
        });
        GetLignesVoyages(parsedAuthState.token, ModifierLingesVoyage.voyage_principal_id);
      })
      .catch((err) => {
        console.error('Errors :', err);
      })

  };


  const [errorsLingesVoyages, setErrorsLingesVoyages] = useState({
    error: false,
    message: "",
  })

  const handleOpenLingesVoyages = () => {
    setLingesVoyagesOpen(true);
  };
  const [openDialogConfimerAjouter, SetOpenDialogConfimerAjouter] = useState(false);
  const handleOpenDialogConfimerAjouter = () => {
    SetOpenDialogConfimerAjouter(true);
  }
  const handleCloseDialogConfimerAjouter = () => {
    SetOpenDialogConfimerAjouter(false);
  }

  const handleCloseLingesVoyages = () => {
    handleOpenDialogConfimerAjouter();
  };

  const handleConfirmerClose = () => {

    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);
    setLingesVoyagesOpen(false); // Close the popup
    setAlertOpen(true);
    handleClose();
    fetchVoyages(parsedAuthState.token);
    setNewVoyage({
      Client_facturation: "",
      ID_Vehicule: "",
      Date_chargement: dayjs().format('DD-MM-YYYY HH:mm'), // ✅ Correct
      Date_déchargement: "",
      Expediteur: "",
      Destinataire: "",
      Coût_Total: "",
      prix_total_voyage: "",
      Statut: "Réserver",
      Nombre_palettes: "",
      Type_de_moyen: "",
      Type_Voyage: "",
      Fournisseur: "",
      N_CMR: "",
      Scellés_Douane: "",
      BL_Number: "",
      Prix_de_Moyen: "",
      Immobilisation: "",
      N_jours: "",
      Prix_Immobilisation: "",
      Prestation: "",
      Prix_Prestation: "",
      ID_Tarification: "",
      Motif_Annulation: "",
      Commentaire_Annulation: "",
      ID_Tarification: "",
    });

    handleCloseDialogConfimerAjouter();
  }

  const handleAjouterLignesVoyages = () => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);
    console.log(newLingesVoyages);
    if (
      newLingesVoyages.destinataire === "" ||
      newLingesVoyages.expediteur === ""
    ) {
      setErrorsLingesVoyages({ error: true, message: "Ce champ est obligatoire" });
      return;
    }
    else {
      axios
        .post(
          `${API}/lignes-voyage`,
          {
            voyage_principal_id: newLingesVoyages.voyage_principal_id,
            expediteur: newLingesVoyages.expediteur,
            destinataire: newLingesVoyages.destinataire,
            staut: newLingesVoyages.statut,
            commentaires: newLingesVoyages.commentaires,
            //Réserver
          },
          {
            headers: { Authorization: `Bearer ${parsedAuthState.token}` },
          }
        )
        .then((response) => {
          GetLignesVoyages(parsedAuthState.token, newLingesVoyages.voyage_principal_id);


          // handleOpenAlertLigneDeVoyage();
          setErrorsLingesVoyages({ error: false, message: "" });
          logOperation({
            operation_type: "CREATE",
            entity_type: "LIGNES_VOYAGE",
            entity_id: parsedAuthState.user.id,
            description: "Ajout d'une ligne de voyage",
          });
          setNewLingesVoyages({
            voyage_principal_id: newLingesVoyages.voyage_principal_id,
            expediteur: "",
            destinataire: "",
            statut: "Réserver",
            commentaires: "",
          });
        })
        .catch((error) => {
          GetLignesVoyages(parsedAuthState.token, newLingesVoyages.voyage_principal_id);
          console.error("Erreur lors de l'ajout du la ligne de voyage :", error);
          setErrorsLingesVoyages({ error: true, message: "Erreur lors de l'ajout de la ligne de voyage" });
        })
    }
  }


  const handleDelete = (id) => {

    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);
    axios
      .delete(`${API}/lignes-voyage/${id}`, {
        headers: { Authorization: `Bearer ${parsedAuthState.token}` },
      })
      .then((response) => {
        GetLignesVoyages(parsedAuthState.token, id);
        handleOpenAlertDeleteLigneDeVoyage();
        logOperation({
          operation_type: "DELETE",
          entity_type: "Ligne de voyage",
          entity_id: parsedAuthState.user.id,
          description: "Delete des informations de la ligne de voyage",
        });
      }).catch((error) => {
        console.error("Error Response:", error.response.data.error);
      })


  };

  // Get linges voyages by id voyage
  const GetLignesVoyages = async (token, id) => {

    await axios
      .get(`${API}/voyages/${id}/lignes`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setLignesVoyages(response.data.data);
      })
      .catch((error) => {
        console.error(
          "Erreur lors de les lignes de voyages",
          error
        );
      });
  }
  const [alertLigneDeVoyage, setAlertLigneDeVoyage] = useState(false);

  const handleOpenAlertLigneDeVoyage = () => {
    setAlertLigneDeVoyage(true);
  }

  const handleCloseAlertLigneDeVoyage = () => {
    setAlertLigneDeVoyage(false);
  }

  const [alertDeleteLigneDeVoyage, setAlertDeleteLigneDeVoyage] = useState(false);

  const handleOpenAlertDeleteLigneDeVoyage = () => {
    setAlertDeleteLigneDeVoyage(true);
  }

  const handleCloseAlertDeleteLigneDeVoyage = () => {
    setAlertDeleteLigneDeVoyage(false);
  }


  {
    /* end drawer for new vehicle */
  }
  const [typeClients, setTypeClients] = useState([
    { label: 'Entreprise', value: 'Entreprise' },
    { label: 'Particulier', value: 'Particulier' },
    { label: 'Autre', value: 'Autre' },
  ]);
  const handleAjouterClient = () => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);

    // Champs requis avec libellés
    const requiredFields = [
      { key: "Nom", label: "Nom" },
      { key: "Code_client", label: "Code client" },
      { key: "Contact", label: "Contact" },
      { key: "Email", label: "Email" },
      { key: "Type_Client", label: "Type de client" },
    ];

    // Vérifier les champs requis
    const missingFields = requiredFields
      .filter(({ key }) => !newClient[key] || newClient[key].toString().trim() === "")
      .map(({ label }) => label);

    if (missingFields.length > 0) {
      setErrorsClient({
        error: true,
        message: `Les champs suivants sont obligatoires : ${missingFields.join(", ")}`,
      });
      return;
    }

    // Envoi à l'API
    axios
      .post(
        `${API}/clients`,
        {
          Nom: newClient.Nom,
          Adresse: newClient.Adresse,
          Email: newClient.Email,
          Contact: newClient.Contact,
          Type_Client: newClient.Type_Client,
          Raison_sociale: newClient.Raison_sociale,
          Forme_juridique: newClient.Forme_juridique,
          Code_client: newClient.Code_client,
          Sites: newClient.Sites,
          IF: newClient.IF,
          ICE: newClient.ICE,
          taux_de_TVA: newClient.taux_de_TVA,
          Mode_de_reglement: newClient.Mode_de_reglement,
          Echéance_de_reglement: newClient.Echéance_de_reglement,
          Activité: newClient.Activité,
        },
        {
          headers: { Authorization: `Bearer ${parsedAuthState.token}` },
        }
      )
      .then((response) => {
        handleOpenAlertNouveauClient();
        handleCloseDrawerClient();
        GetClients();

        setNewClient({
          Nom: '',
          Adresse: '',
          Email: '',
          Contact: '',
          Type_Client: '',
          Raison_sociale: '',
          Forme_juridique: '',
          Code_client: '',
          Sites: '',
          IF: '',
          ICE: '',
          taux_de_TVA: '',
          Mode_de_reglement: '',
          Echéance_de_reglement: '',
          Activité: '',
        });

        logOperation({
          operation_type: "CREATE",
          entity_type: "Client in Voyage",
          entity_id: parsedAuthState.user.id,
          description: "Ajout d'un client pour un voyage",
        });
      })
      .catch((error) => {
        console.error("Erreur lors de l'ajout du client:", error);
        setErrorsClient({
          error: true,
          message: error?.response?.data?.message || "Erreur inconnue",
        });
      });
  };



  {
    /**  end Drawer client   */
  }

  // update scelle utilise
  const updateScellesUtilise = async (ids, token, use) => {
    try {
      await Promise.all(
        ids.map((id) =>
          axios.put(
            `${API}/scelles/UpdateUtilise/${id}`,
            { utilise: use },
            { headers: { Authorization: `Bearer ${token}` } }
          )
        )
      );
      console.log("Mise à jour terminée");
    } catch (error) {
      console.error("Erreur lors de la mise à jour des scellés:", error);
    }
  };

  // helpers

  const serializeIds = (val) => {
    const arr = Array.isArray(val) ? val : (val == null || val === '' ? [] : [val]);
    const vals = arr.map(v => String(v).trim()).filter(Boolean);
    return vals.length ? Array.from(new Set(vals)).join('/') : null; // "2/5/8"
  };

  const strOrNull = (v) => {
    const s = String(v ?? '').trim();
    return s ? s : null;
  };

  const numOrNull = (v) => {
    const n = parseFloat(String(v ?? '').replace(',', '.'));
    return Number.isFinite(n) ? n : null;
  };

  const intOrNull = (v) => {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : null;
  };

  // robust date parse (accepts DD-MM-YYYY HH:mm, YYYY-MM-DD HH:mm:ss, etc.)
  const isoOrNull = (v) => {
    if (!v) return null;
    if (dayjs.isDayjs(v)) return v.format('YYYY-MM-DD HH:mm:ss');
    const fmts = [
      'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm',
      'DD-MM-YYYY HH:mm', 'DD/MM/YYYY HH:mm',
      'YYYY-MM-DD', 'DD-MM-YYYY', 'DD/MM/YYYY'
    ];
    for (const f of fmts) {
      const d = dayjs(v, f, true);
      if (d.isValid()) return d.format('YYYY-MM-DD HH:mm:ss');
    }
    const d = dayjs(v);
    return d.isValid() ? d.format('YYYY-MM-DD HH:mm:ss') : null;
  };

  // ---- submit
  const handleAjouterVoyage = async () => {
    const required = [
      { key: "Client_facturation", label: "Client facturation" },
      { key: "Date_chargement", label: "Date de chargement" },
      { key: "Expediteur", label: "Expéditeur" },
    ];

    const missing = required
      .filter(({ key }) => !newVoyage[key])
      .map(({ label }) => label);

    if (missing.length) {
      setErrors({ error: true, message: `Les champs suivants sont requis : ${missing.join(" , ")}` });
      return;
    }

    try {
      const token = JSON.parse(sessionStorage.getItem("authLocalstorage"))?.token;
      const parsedAuthState = JSON.parse(sessionStorage.getItem('authLocalstorage'));

      const voyageData = {
        Client_facturation: newVoyage.Client_facturation,
        ID_Vehicule: newVoyage.ID_Vehicule || null,

        // fix dates: parse to SQL format
        Date_chargement: isoOrNull(newVoyage.Date_chargement),
        Date_déchargement: isoOrNull(newVoyage.Date_déchargement),

        Expediteur: strOrNull(newVoyage.Expediteur),
        Destinataire: strOrNull(newVoyage.Destinataire),

        Coût_Total: numOrNull(newVoyage.Coût_Total),
        prix_total_voyage: numOrNull(newVoyage.prix_total_voyage),

        Statut: strOrNull(newVoyage.Statut) || "Réserver",
        Nombre_palettes: intOrNull(newVoyage.Nombre_palettes),
        Type_de_moyen: strOrNull(newVoyage.Type_de_moyen),
        Type_Voyage: strOrNull(newVoyage.Type_Voyage),
        Fournisseur: newVoyage.Fournisseur ?? null,

        // strings expected by DB
        N_CMR: serializeIds(newVoyage.N_CMR),
        N_CMR_RT: serializeIds(newVoyage.N_CMR_RT),
        N_DUM: serializeIds(newVoyage.N_DUM),
        N_DUM_RT: serializeIds(newVoyage.N_DUM_RT),

        // DB column is VARCHAR(255) -> send string, not array
        Scellés_Douane: serializeIds(newVoyage.Scellés_Douane),

        BL_Number: strOrNull(newVoyage.BL_Number),
        Prix_de_Moyen: numOrNull(newVoyage.Prix_de_Moyen),
        Immobilisation: strOrNull(newVoyage.Immobilisation),
        N_jours: intOrNull(newVoyage.N_jours),
        Prix_Immobilisation: numOrNull(newVoyage.Prix_Immobilisation),
        Prestation: strOrNull(newVoyage.Prestation),
        Type_de_prestation: strOrNull(newVoyage.Type_de_prestation),
        Prix_Prestation: numOrNull(newVoyage.Prix_Prestation),
        ID_Tarification: newVoyage.ID_Tarification ?? null,
      };

      await axios.post(`${API}/voyages`, voyageData, {
        headers: { Authorization: `Bearer ${token}` },
      }).then((response) => {
        if (newVoyage.Type_Voyage === "Groupage") {
          handleOpenLingesVoyages();
          newLingesVoyages.voyage_principal_id = response.data.data.ID_Voyage;

        }
        else {
          
          setAlertOpen(true); handleClose();
          setNewVoyage({ Client_facturation: "", ID_Vehicule: "", Date_chargement: dayjs().format("DD-MM-YYYY HH:mm"), Date_déchargement: "", Expediteur: "", Destinataire: "", Coût_Total: "", prix_total_voyage: "", Statut: "Réserver", Nombre_palettes: "", Type_de_moyen: "", Type_Voyage: "", Fournisseur: "", N_CMR: "", Scellés_Douane: "", BL_Number: "", Prix_de_Moyen: "", Immobilisation: "", N_jours: "", Prix_Immobilisation: "", Prestation: "", Prix_Prestation: "", ID_Tarification: "", Motif_Annulation: "", Commentaire_Annulation: "", });
        }
        setErrors({ error: false, message: "" });
        updateScellesUtilise(newVoyage.Scellés_Douane, parsedAuthState.token, 1);
        GetScelles(token);
        fetchVoyages(token);
        logOperation({ operation_type: "CREATION", entity_type: "Voyage", entity_id: parsedAuthState.user.id, description: "Ajout d'un voyage", });
        
      });
      // ... success handling ...
    } catch (error) {
      console.error("Erreur lors de l'ajout du voyage:", error);
      let message = "Une erreur est survenue";
      if (error.response) { message = error.response.data.message || message; } else if (error.request) { message = "Erreur de connexion au serveur"; } else { message = error.message; } setErrors({ error: true, message }); toast.error("Erreur lors de l'ajout du voyage");
    }
  };





  // Si vous utilisez un composant DateTimePicker, assurez-vous qu'il renvoie une date au format ISO

  const handleDateFinChange = (date) => {
    setNewVoyage((prev) => ({
      ...prev,
      Date_déchargement: date,
    }));
  };

  const isAllowedAjouterVoyage = getPermission(
    Permissions,
    "voyages",
    "ajouter voyage"
  );
  const isAllowedModifierVoyage = getPermission(
    Permissions,
    "voyages",
    "modifier voyage"
  );
  const isAllowedSupprimerVoyage = getPermission(
    Permissions,
    "voyages",
    "supprimer voyage"
  );
  const isAllowedExporterVoyage = getPermission(
    Permissions,
    "voyages",
    "exporter voyage"
  );
  const isAllowedImporterVoyage = getPermission(
    Permissions,
    "voyages",
    "importer voyage"
  );

  const isAllowedConfirmerVoyage = getPermission(
    Permissions,
    "voyages",
    "confirmer voyage"
  );

  const isAllowedAnnulerVoyage = getPermission(
    Permissions,
    "voyages",
    "annuler voyage"
  );



  // Ajoutez ces états pour le dialogue de confirmation
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [selectedVoyageDetails, setSelectedVoyageDetails] = useState([]);


  // Ajoutez cette nouvelle fonction pour la confirmation finale

  // Ajoutez ce composant de dialogue
  const ConfirmationDialog = () => {
    // États locaux pour le formulaire
    const [localBlNumber, setLocalBlNumber] = useState('');
    const [localPassword, setLocalPassword] = useState('');
    const [localError, setLocalError] = useState('');

    // Fonction de nettoyage
    const resetForm = () => {
      setLocalBlNumber('');
      setLocalPassword('');
      setLocalError('');
    };

    // Gestion de la fermeture
    const handleClose = () => {
      resetForm();
      setConfirmDialogOpen(false);
      setSelectedVoyageDetails(null);
    };

    // Gestion de la soumission
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (!localBlNumber) {
        setLocalError('Veuillez saisir le numéro BL');
        return;
      }
      if (!localPassword) {
        setLocalError('Veuillez saisir votre mot de passe');
        return;
      }

      try {
        const storedAuthState = sessionStorage.getItem("authLocalstorage");
        const parsedAuthState = JSON.parse(storedAuthState);

        // Vérifier le mot de passe
        const verifyResponse = await axios.post(
          `${API}/verify-password`,
          {
            email: parsedAuthState.user.email,
            password: localPassword
          }
        );

        if (!verifyResponse.data.success) {
          setLocalError('Mot de passe incorrect');
          return;
        }

        // Mise à jour du statut et du numéro BL
        const response = await axios.patch(
          `${API}/voyages/${selectedVoyageDetails.ID_Voyage}/statut`,
          {
            Statut: "Réalisé",
            BL_Number: localBlNumber
          },
          {
            headers: { Authorization: `Bearer ${parsedAuthState.token}` }
          }
        );

        if (response.data) {
          toast.success("Voyage confirmé avec succès");
          handleClose();
          fetchVoyages(parsedAuthState.token);
          setAlertOpenConfirmVoyage(true);
          logOperation({
            operation_type: "Confirmer voyage",
            entity_type: "Voyage",
            entity_id: parsedAuthState.user.id,
            description: "Confirmer voyage",
          });
        }
      } catch (error) {
        console.error("Erreur:", error);
        setLocalError(error.response?.data?.message || 'Une erreur est survenue');
      }
    };

    return (
      <Dialog
        open={confirmDialogOpen}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            p: 2,
            position: 'relative'
          }
        }}
      >
        <form onSubmit={handleSubmit}>
          <DialogTitle>
            Confirmation du voyage
            {selectedVoyageDetails &&
              ` N° ${selectedVoyageDetails.ID_Voyage}`
            }
          </DialogTitle>

          <DialogContent>
            <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
              {selectedVoyageDetails && (
                <Grid container spacing={2} sx={{ mb: 2 }}>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary">
                      Client:
                    </Typography>
                    <Typography variant="body1" fontWeight="500">
                      {clients.find(client => client.ID_Client === selectedVoyageDetails.Client_facturation)?.Raison_sociale || 'Client inconnu'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary">
                      Statut actuel:
                    </Typography>
                    <Typography variant="body1" fontWeight="500">
                      {selectedVoyageDetails.Statut}
                    </Typography>
                  </Grid>
                </Grid>
              )}

              <TextField
                fullWidth
                label="Numéro BL"
                value={localBlNumber}
                onChange={(e) => {
                  setLocalBlNumber(e.target.value);
                  setLocalError('');
                }}
                error={Boolean(localError && !localBlNumber)}
                helperText={localError && !localBlNumber ? localError : ''}
              />

              <TextField
                fullWidth
                label="Mot de passe"
                type="password"
                value={localPassword}
                onChange={(e) => {
                  setLocalPassword(e.target.value);
                  setLocalError('');
                }}
                error={Boolean(localError)}
                helperText={localError}
              />
            </Box>
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              startIcon={<CloseIcon />}
            >
              Annuler
            </Button>
            <Button
              variant="contained"
              type="submit"
              sx={{ bgcolor: '#1D3E62' }}
              startIcon={<CheckCircleIcon />}
            >
              Confirmer
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );

  };


  const [confirmMultiDialogOpen, setConfirmMultiDialogOpen] = useState(false);
  const [selectedVoyagesToConfirm, setSelectedVoyagesToConfirm] = useState([]);
  const handleConfirmVoyage = async () => {
    const selectedRows = JSON.parse(localStorage.getItem("selectedRows") || "[]");

    if (!selectedRows || selectedRows.length === 0) {
      setAlertOpenSelectedModifier(true);
      return;
    }

    const invalidVoyage = selectedRows.find(
      (row) => row.Statut === "Réalisé" || row.Statut === "Annulé"
    );

    if (invalidVoyage?.Statut === "Réalisé") {
      setAlertVoyageDejaTermine(true);
      return;
    }

    if (invalidVoyage?.Statut === "Annulé") {
      setAlertVoyageDejaAnnule(true);
      return;
    }

    setRowsSelected(selectedRows);

    if (selectedRows.length === 1) {
      setSelectedVoyageDetails(selectedRows[0]);
      setConfirmDialogOpen(true);
      return;
    }

    setSelectedVoyagesToConfirm(
      selectedRows.map((row) => ({
        ...row,
        BL_Number: row.BL_Number || "",
      }))
    );

    setConfirmMultiDialogOpen(true);
  };

  const ConfirmationMultiVoyagesDialog = () => {
    const [localVoyages, setLocalVoyages] = useState([]);
    const [localPassword, setLocalPassword] = useState("");
    const [localError, setLocalError] = useState("");

    useEffect(() => {
      if (confirmMultiDialogOpen) {
        setLocalVoyages(selectedVoyagesToConfirm);
        setLocalPassword("");
        setLocalError("");
      }
    }, [confirmMultiDialogOpen]);

    const handleClose = () => {
      setConfirmMultiDialogOpen(false);
      setSelectedVoyagesToConfirm([]);
      setLocalVoyages([]);
      setLocalPassword("");
      setLocalError("");
    };

    const handleBlChange = (idVoyage, value) => {
      setLocalVoyages((prev) =>
        prev.map((voyage) =>
          voyage.ID_Voyage === idVoyage
            ? { ...voyage, BL_Number: value }
            : voyage
        )
      );
      setLocalError("");
    };

    const handleSubmit = async (e) => {
      e.preventDefault();

      const emptyBl = localVoyages.find(
        (voyage) => !String(voyage.BL_Number || "").trim()
      );

      if (emptyBl) {
        setLocalError(`Veuillez saisir le BL du voyage N° ${emptyBl.ID_Voyage}`);
        return;
      }

      if (!localPassword) {
        setLocalError("Veuillez saisir votre mot de passe");
        return;
      }

      try {
        const storedAuthState = sessionStorage.getItem("authLocalstorage");
        const parsedAuthState = JSON.parse(storedAuthState);
        const token = parsedAuthState.token;

        const verifyResponse = await axios.post(`${API}/verify-password`, {
          email: parsedAuthState.user.email,
          password: localPassword,
        });

        if (!verifyResponse.data.success) {
          setLocalError("Mot de passe incorrect");
          return;
        }

        await Promise.all(
          localVoyages.map((voyage) =>
            axios.patch(
              `${API}/voyages/${voyage.ID_Voyage}/statut`,
              {
                Statut: "Réalisé",
                BL_Number: voyage.BL_Number,
              },
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            )
          )
        );

        toast.success("Voyages confirmés avec succès");
        setAlertOpenConfirmVoyage(true);
        handleClose();
        fetchVoyages(token);
      } catch (error) {
        console.error("Erreur confirmation voyages:", error);
        setLocalError(error.response?.data?.message || "Une erreur est survenue");
      }
    };

    return (
      <Dialog open={confirmMultiDialogOpen} onClose={handleClose} maxWidth="md" fullWidth>
        <form onSubmit={handleSubmit}>
          <DialogTitle>Confirmation des voyages sélectionnés</DialogTitle>

          <DialogContent>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
              {localVoyages.map((voyage) => (
                <Paper key={voyage.ID_Voyage} sx={{ p: 2, borderRadius: 2 }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={4}>
                      <Typography fontWeight={700}>
                        Voyage N° {voyage.ID_Voyage}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Statut : {voyage.Statut}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <TextField
                        fullWidth
                        label="Numéro BL"
                        value={voyage.BL_Number || ""}
                        onChange={(e) =>
                          handleBlChange(voyage.ID_Voyage, e.target.value)
                        }
                      />
                    </Grid>
                  </Grid>
                </Paper>
              ))}

              <TextField
                fullWidth
                label="Mot de passe"
                type="password"
                value={localPassword}
                onChange={(e) => {
                  setLocalPassword(e.target.value);
                  setLocalError("");
                }}
                error={Boolean(localError)}
                helperText={localError}
              />
            </Box>
          </DialogContent>

          <DialogActions>
            <Button variant="outlined" onClick={handleClose}>
              Annuler
            </Button>
            <Button variant="contained" type="submit" sx={{ bgcolor: "#1D3E62" }}>
              Confirmer tous
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  };
  // Ajoutez ces états pour l'alerte d'annulation
  const [alertOpenAnnulation, setAlertOpenAnnulation] = useState(false);

  const handleAlertCloseAnnulation = () => {
    setAlertOpenAnnulation(false);
  };

  // Ajoutez cet état pour la boîte de dialogue de confirmation d'annulation
  const [confirmAnnulationDialog, setConfirmAnnulationDialog] = useState(false);

  // Ajoutez cette fonction pour gérer la confirmation
  const handleConfirmOpenAnnulation = () => {
    setConfirmAnnulationDialog(false);
    const selectedRows = JSON.parse(localStorage.getItem("selectedRows") || "[]");
    setSelectedVoyageForAnnulation(selectedRows[0]);
    setAnnulationDialog(true);
  };

  // Ajoutez ce composant de dialogue de confirmation
  const ConfirmAnnulationDialog = () => {
    return (
      <Dialog
        open={confirmAnnulationDialog}
        onClose={() => setConfirmAnnulationDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{
          bgcolor: '#f8f9fa',
          borderBottom: '1px solid #dee2e6'
        }}>
          Confirmation d'annulation
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Typography>
            Êtes-vous sûr de vouloir annuler ce voyage ? Cette action nécessitera une justification et ne pourra pas être annulée.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, bgcolor: '#f8f9fa' }}>
          <Button
            onClick={() => setConfirmAnnulationDialog(false)}
            variant="outlined"
            startIcon={<CloseIcon />}
          >
            Annuler
          </Button>
          <Button
            onClick={handleConfirmOpenAnnulation}
            variant="contained"
            color="error"
            startIcon={<CheckCircleIcon />}
            sx={{ ml: 1 }}
          >
            Continuer
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  // Ajouter ces nouveaux états pour les alertes
  const [alertVoyageDejaTermine, setAlertVoyageDejaTermine] = useState(false);
  const [alertVoyageDejaAnnule, setAlertVoyageDejaAnnule] = useState(false);
  return (
    <ThemeProvider theme={theme}>
      {token === false ? (
        <TokenExpired />
      ) : (
        (role === "user" || role === "admin" || role === "super-admin" || role === "user-facture") && (
          <Box
            sx={{
              flexGrow: 1,
              backgroundColor: '#f8fafc',
              padding: { xs: '16px', md: '20px' },
              minHeight: '120vh',
              transition: 'all 0.3s ease-in-out',
            }}
          >
            <MenuButton />
            <Box sx={{
              backgroundColor: 'white',
              borderRadius: '8px',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
              border: '1px solid #e5e7eb',
              overflow: 'hidden'
            }}>
              <DataGrid2Table data={Voyages} columns={columns} />
            </Box>
          </Box>
        )
      )}

      {/* begin model ajouter Voyage  */}
      <BasicModal
        open={openAjouterVoyage}
        onClose={handleClose}
        widthSpecial={"85%"}
        ChildrenContent={
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
              height: {
                xs: "90vh",
                sm: "90vh",
                md: "85vh",
                lg: "80vh",
                xl: "75vh",
              },
              display: "flex",
              flexDirection: "column",
              p: 2,
            }}
          >
            {/* Header */}
            <Typography
              variant="h4"
              sx={{
                fontSize: "18px",
                color: "#1D3E62",
                fontWeight: "600",
                textAlign: "center",
                mb: 0.5,
                borderBottom: "1px solid rgba(29, 62, 98, 0.2)",
                pb: 1,
              }}
            >
              Nouveau Voyage
            </Typography>

            {/* Scrollable Content */}
            <Box
              sx={{
                flex: 1,
                overflow: "auto",
                px: 0.5,
              }}
            >
              {/* Informations Principales */}
              <Box sx={{ mb: 1.5 }}>
                <Typography
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    fontSize: "14px",
                    color: "#1D3E62",
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  <PersonIcon sx={{ fontSize: "16px" }} /> Informations Principales
                </Typography>
                <Grid container spacing={2} sx={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }} >
                  <Grid item xs={12} md={12} lg={12} xl={12} >
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1 }}>
                      <AutocompleteComboBox
                        required={true}
                        widthSpecific={'270px'}
                        Label={"Client facturation"}
                        list={clients}
                        keyField={"ID_Client"} // Assurez-vous que ces champs correspondent à votre API
                        valueField={"Nom"} // Assurez-vous que ces champs correspondent à votre API
                        onChange={handleSelectionChangeID_Client}
                        value={newVoyage.Client_facturation}
                        error={errors.error && !newVoyage.Client_facturation}
                        helperText={
                          errors.error && !newVoyage.Client_facturation
                            ? "Client requis"
                            : ""
                        }
                      />
                      <Box sx={{ display: "flex", alignItems: "center", paddingTop: 1.5 }} >
                        <ButtonAttribute
                          Bgcolor={"#1D3E62"}
                          action={handleOpenDrawerClient}
                          startIcon={<FontAwesomeIcon icon={faPlus} color='#fff' style={{ fontSize: '16px', marginLeft: '15px' }} />}
                          width={'35px'}
                          height={'40px'}

                        />
                      </Box>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={12} lg={3} xl={5}>

                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1 }}>
                      <FormControlLabel
                        control={<Radio checked={selectedType === 'Interne'} onChange={handleRadioChange} value="Interne" />}

                      />
                      <AutocompleteComboBox
                        disable={checked.Externe}
                        required={true}
                        widthSpecific={'270px'}
                        Label={"Véhicules"}
                        list={vehicules}
                        keyField={"id"} // Assurez-vous que ces champs correspondent à votre API
                        valueField={"matricule"} // Assurez-vous que ces champs correspondent à votre API
                        onChange={handleSelectionChangeVehicule}
                        value={newVoyage.ID_Vehicule}
                        error={errors.error && !newVoyage.ID_Vehicule}
                        helperText={
                          errors.error && !newVoyage.ID_Vehicule
                            ? "Véhicule requis"
                            : ""
                        }
                      />
                      <Box sx={{ display: "flex", alignItems: "center", paddingTop: 1.5 }} >
                        <ButtonAttribute
                          disabled={checked.Externe}
                          Bgcolor={"#1D3E62"}
                          action={handleOpenDrawerVehicule}
                          startIcon={<FontAwesomeIcon icon={faPlus} color='#fff' style={{ fontSize: '16px', marginLeft: '15px' }} />}
                          width={'35px'}
                          height={'40px'}
                        />
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={12} lg={3} xl={5}  >
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1 }}>
                      <FormControlLabel
                        control={<Radio checked={selectedType === 'Externe'} onChange={handleRadioChange} value="Externe" />}

                      />

                      <AutocompleteComboBox
                        disable={checked.Interne}
                        required={true}
                        widthSpecific={'270px'}
                        Label={"Fourrnisseur"}
                        list={fournisseurs}
                        keyField={"id"} // Assurez-vous que ces champs correspondent à votre API
                        valueField={"Nom"} // Assurez-vous que ces champs correspondent à votre API
                        onChange={handleSelectionChangeFournisseur}
                        value={newVoyage.Fournisseur}
                        error={errors.error && !newVoyage.Fournisseur}
                        helperText={
                          errors.error && !newVoyage.Fournisseur
                            ? "Véhicule requis"
                            : ""
                        }
                      />
                      <Box sx={{ display: "flex", alignItems: "center", paddingTop: 1.5 }} >
                        <ButtonAttribute
                          disabled={checked.Interne}
                          Bgcolor={"#1D3E62"}
                          action={handleOpenDrawerFournisseur}
                          startIcon={<FontAwesomeIcon icon={faPlus} color='#fff' style={{ fontSize: '16px', marginLeft: '15px' }} />}
                          width={'35px'}
                          height={'40px'}
                        />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              {/* Dates du Voyage */}
              <Box sx={{ mb: 1.5 }}>
                <Typography
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    fontSize: "14px",
                    color: "#1D3E62",
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  <CalendarTodayIcon sx={{ fontSize: "16px" }} /> Dates du Voyage
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <DateTimePickerComponent
                      required={true}
                      typeDate={"datetime"}
                      label="Date Chargement"
                      dateSelected={(date) => {
                        setNewVoyage({ ...newVoyage, Date_chargement: date });
                      }}
                      value={newVoyage.Date_chargement}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <DateTimePickerComponent
                      typeDate={"datetime"}
                      label="Date Dechargement"
                      dateSelected={handleDateFinChange}
                      value={newVoyage.Date_déchargement}
                    />

                  </Grid>
                </Grid>
              </Box>

              {/* Détails de l'Itinéraire */}
              <Box sx={{ mb: 1.5 }}>
                <Typography
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    fontSize: "14px",
                    color: "#1D3E62",
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  <LocationOnIcon sx={{ fontSize: "16px" }} /> Détails de l'Itinéraire
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <AutocompleteComboBox
                      required={true}
                      widthSpecific={"100%"}
                      Label={"Expéditeur - Destination"}
                      list={VillesTarificationByClient}
                      keyField="id"
                      departField="depart"
                      destinationField="destination"
                      dueShowValue={true}
                      ToValue={true}
                      onChange={(newValue) => {
                        if (newValue) {
                          setNewVoyage((prev) => ({
                            ...prev,
                            ID_Tarification: newValue.id,
                            Expediteur: newValue.depart,
                            Destinataire: newValue.destination   // Store selected ID or other fields
                          }));
                          const selectedVille = VillesTarificationByClient.find((ville) => ville.id === newValue.id);
                          setDestinationType(selectedVille);

                        } else {

                        }
                      }}
                      value={parseInt(newVoyage.ID_Tarification) || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextInputMui
                      required={true}
                      disabled={true}
                      widthSpecific={"100%"}
                      label={"Statut"}
                      value={newVoyage.Statut}
                      onChange={(e) => setNewVoyage({ ...newVoyage, Statut: e.target.value })}
                    />
                  </Grid>
                </Grid>
              </Box>

              {/* Informations Complémentaires */}
              <Box sx={{ mb: 1.5 }}>
                <Typography
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    fontSize: "14px",
                    color: "#1D3E62",
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  <InfoIcon sx={{ fontSize: "16px" }} /> Informations +
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} lg={4} >
                    <AutocompleteComboBox
                      required={true}
                      widthSpecific={"100%"}
                      Label={"Type de Moyen"}
                      list={[
                        { id: "taxi", Nom: "Taxi" },
                        { id: "T3_5", Nom: "Camion lourd 3/5 T" },
                        { id: "T7", Nom: "Camion léger 7 T" },
                        { id: "T14", Nom: "Camion lourd 14 T" },
                        { id: "T18", Nom: "Camion lourd 18 T" },
                        { id: "Tracteur", Nom: "Tracteur" },
                        { id: "semi_remorque", Nom: "Semi remorque" }
                      ]}
                      keyField={"id"}
                      valueField={"Nom"}
                      value={newVoyage.Type_de_moyen}
                      onChange={(key) => {
                        let coutTotal = "";

                        switch (key) {
                          case "taxi":
                            coutTotal = destinationType.taxi;
                            break;
                          case "T3_5":
                            coutTotal = destinationType.T3_5;
                            break;
                          case "T7":
                            coutTotal = destinationType.T7;
                            break;
                          case "T14":
                            coutTotal = destinationType.T14;
                            break;
                          case "T18":
                            coutTotal = destinationType.T18;
                            break;
                          case "Tracteur":
                            coutTotal = destinationType.Tracteur;
                            break;
                          case "semi_remorque":
                            coutTotal = destinationType.semi_remorque;
                            break;
                          default:
                            coutTotal = "";
                        }

                        setNewVoyage({
                          ...newVoyage,
                          Type_de_moyen: key,
                          Coût_Total: coutTotal
                        });

                      }}
                    />

                  </Grid>
                  <Grid item xs={12} md={6} lg={4} sx={{ display: "flex", justifyContent: "space-between", gap: 1 }} >
                    <AutocompleteComboBox
                      required={true}
                      widthSpecific={'100%'}
                      Label={"Type de Voyage"}
                      list={[
                        { id: "Aller simple", Nom: "Aller simple" },
                        { id: "Aller retour", Nom: "Aller retour" },
                        { id: "Navette", Nom: "Navette" },
                        { id: "Groupage", Nom: "Groupage" },
                      ]}
                      keyField={"Nom"} // Assurez-vous que ces champs correspondent à votre API
                      valueField={"Nom"} // Assurez-vous que ces champs correspondent à votre API 
                      onChange={(key) => setNewVoyage({ ...newVoyage, Type_Voyage: key })}
                      value={newVoyage.Type_Voyage}
                    />

                  </Grid>

                  <Grid item xs={12} md={6} lg={4}>
                    <TextInputMui
                      required={true}
                      label="Coût Total"
                      type="number"
                      value={newVoyage.Coût_Total}
                      setValue={(e) =>
                        setNewVoyage({ ...newVoyage, Coût_Total: e })
                      }
                    />
                  </Grid>
                </Grid>
              </Box>

              {/* Documents */}
              <Box sx={{ mb: 1.5, mt: 0.5 }}>

                <Grid container spacing={2}  >

                  <Grid item xs={12} md={6} lg={4}>
                    <TextInputMuiMult
                      multiple
                      label="N°CMR"
                      values={newVoyage.N_CMR || []}
                      setValues={(arr) => setNewVoyage({ ...newVoyage, N_CMR: arr })}
                    />
                  </Grid>

                  <Grid item xs={12} md={6} lg={4}>
                    <TextInputMuiMult
                      multiple
                      label="N°DUM "
                      values={newVoyage.N_DUM || []}
                      setValues={(arr) => setNewVoyage({ ...newVoyage, N_DUM: arr })}
                    />

                  </Grid>

                  <Grid item xs={12} md={6} lg={4}>

                    <SelectChips
                      widthSpecific="100%"
                      Label="Scellés Douane"
                      list={scelles.filter((s) => s.statut == "Disponible" || s.statut != "Utilisé")}
                      keyField="id"
                      valueField="numero_scelle"
                      value={newVoyage.Scellés_Douane ?? []}          // e.g. [3, 5, 8]
                      ToValue={false}                                  // return only IDs
                      onChange={(ids) =>                              // ids => [id, id, ...]
                        setNewVoyage((prev) => ({ ...prev, Scellés_Douane: ids }))
                      }
                    />

                  </Grid>
                  {newVoyage.Type_Voyage == "Aller retour" && (
                    <Grid item xs={12} md={newVoyage.Type_Voyage == "Aller retour" ? 4 : 2}>

                      <TextInputMuiMult
                        multiple
                        label="N°CMR Retour"
                        values={newVoyage.N_CMR_RT || []}
                        setValues={(arr) => setNewVoyage({ ...newVoyage, N_CMR_RT: arr })}
                      />
                    </Grid>
                  )}
                  {newVoyage.Type_Voyage == "Aller retour" && (
                    <Grid item xs={12} md={6} lg={4}>


                      <TextInputMuiMult
                        multiple
                        label="N°DUM RT"
                        values={newVoyage.N_DUM_RT || []}
                        setValues={(arr) => setNewVoyage({ ...newVoyage, N_DUM_RT: arr })}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} md={6} lg={newVoyage.Type_Voyage == "Aller retour" ? 4 : 2}>
                    <TextInputMui
                      label="Nombre Palettes"
                      type="number"
                      value={newVoyage.Nombre_palettes}
                      setValue={(e) =>
                        setNewVoyage({ ...newVoyage, Nombre_palettes: e })
                      }
                    />
                  </Grid>


                  <Grid item xs={12} md={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={newVoyage.Immobilisation === 'Oui'}
                          onChange={(e) =>
                            setNewVoyage({
                              ...newVoyage,
                              Immobilisation: e.target.checked ? 'Oui' : 'Non',
                            })
                          }
                          color="primary"
                          size="small"
                        />
                      }
                      label={`Immobilisation `}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        border: '1px solid #E0E0E0',
                        borderRadius: '12px',
                        px: 1.5,
                        py: 0.8,
                        backgroundColor: '#F9FAFB',
                        width: '100%',
                        height: '45px',
                        fontSize: '14px',
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextInputMui
                      label="Nombre de jours Immobilisation"
                      type="number"
                      disabled={newVoyage.Immobilisation !== 'Oui'}
                      value={newVoyage.N_jours}
                      setValue={(e) =>
                        setNewVoyage({ ...newVoyage, N_jours: e })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextInputMui
                      label="Prix Immobilisation"
                      type="number"
                      disabled={newVoyage.Immobilisation !== 'Oui'}
                      value={newVoyage.Prix_Immobilisation}
                      setValue={(e) =>
                        setNewVoyage({ ...newVoyage, Prix_Immobilisation: e })
                      }
                    />
                  </Grid>

                  {/* Switch pour activer/désactiver la prestation */}
                  <Grid item xs={12} md={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={newVoyage.Prestation === 'Oui'}
                          onChange={(e) =>
                            setNewVoyage({
                              ...newVoyage,
                              Prestation: e.target.checked ? 'Oui' : 'Non',
                            })
                          }
                          color="primary"
                          size="small"
                        />
                      }
                      label={`Prestation `}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        border: '1px solid #E0E0E0',
                        borderRadius: '12px',
                        px: 1.5,
                        py: 0.8,
                        backgroundColor: '#F9FAFB',
                        width: '100%',
                        height: '45px',
                        fontSize: '14px',
                      }}
                    />
                  </Grid>

                  {/* Champ Prix Prestation désactivé si Prestation !== 'Oui' */}

                  <Grid item xs={12} md={4}>
                    <TextInputMui
                      label="Type Prestation"
                      type="text"
                      disabled={newVoyage.Prestation !== 'Oui'}
                      value={newVoyage.Type_de_prestation}
                      setValue={(e) => {
                        setNewVoyage({ ...newVoyage, Type_de_prestation: e });


                      }
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextInputMui
                      label="Prix Prestation"
                      type="number"
                      disabled={newVoyage.Prestation !== 'Oui'}
                      value={newVoyage.Prix_Prestation}
                      setValue={(e) => {
                        setNewVoyage({ ...newVoyage, Prix_Prestation: e });


                      }
                      }
                    />
                  </Grid>
                  {/* Champ Prix total voyage */}
                  {["user-facture", "admin", "super-admin"].includes(role) && (
                    <Grid item xs={12} md={4}>
                      <TextInputMui
                        label="Prix total voyage"
                        type="number"
                        value={newVoyage.prix_total_voyage}
                        setValue={(e) =>
                          setNewVoyage({ ...newVoyage, prix_total_voyage: e })
                        }
                      />
                    </Grid>
                  )}



                </Grid>
              </Box>
            </Box>




            <Box
              sx={{
                display: "grid",
                justifyContent: "center",
                gap: 2,
                mt: 0.5,
                pt: 1.5,
                borderTop: "1px solid rgba(0,0,0,0.1)",
              }}
            >
              {/* Footer Buttons */}
              {errors.error === true ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mb: 0.5,
                  }}
                >
                  <Typography
                    variant="body2"
                    component="p"
                    sx={{ color: "red", fontWeight: 600, fontSize: "12px" }}
                  >
                    {errors.error === true ? errors.message : " "}
                  </Typography>
                </Box>
              ) : null}
              <Box sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                width: "100%",
              }}
              >
                <ButtonAttribute
                  type="submit"
                  Label="Ajouter Voyage"
                  color={"white"}
                  Bgcolor="#28A745"
                  height={"40px"}
                  width={"150px"}
                  action={() => {
                    handleAjouterVoyage();
                  }}
                />
                <ButtonAttribute
                  Label="Annuler"
                  action={handleClose}
                  Bgcolor="#F3F4F6"
                  color="#374151"
                  bgColorHover="#E5E7EB"
                  width="130px"
                  height="40px"
                  sx={{
                    borderRadius: "6px",
                    textTransform: "none",
                    fontSize: "13px",
                    fontWeight: 500,
                    border: "1px solid #E5E7EB",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      borderColor: "#D1D5DB",
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
        }
      />
      {/* end  model ajouter Voyage */}


      {/* begin  model Linges voyages by voyage  */}
      <BasicModal
        open={LingesVoyagesOpen}
        onClose={handleCloseLingesVoyages}
        widthSpecial={"60%"}
        ChildrenContent={<>
          <Box sx={{ padding: "2px" }}>
            <Typography
              variant="h5"
              sx={{ textAlign: "center", fontWeight: "bold", marginBottom: "16px" }}
            >
              Nouveau Linges de voyages
            </Typography>
            <Divider sx={{ marginBottom: "20px" }} />
            <Grid container spacing={2} sx={{ padding: "20px", gap: 1, display: "flex", justifyContent: "center" }}>
              <Grid xs={12} md={5}>
                <TextInputMui
                  type={"text"}
                  label={'Expediteur'}
                  setValue={(e) => setNewLingesVoyages({ ...newLingesVoyages, expediteur: e })}
                  value={newLingesVoyages.expediteur}
                  required
                />
              </Grid>
              <Grid xs={12} md={5}>
                <TextInputMui
                  type={"text"}
                  label={'Destinataire'}
                  setValue={(e) => setNewLingesVoyages({ ...newLingesVoyages, destinataire: e })}
                  value={newLingesVoyages.destinataire}
                  required
                />
              </Grid>
              <Grid xs={12} md={10}>
                <TextInputMui
                  type={"text"}
                  label={'Commentaire'}
                  multiline={true}

                  setValue={(e) => setNewLingesVoyages({ ...newLingesVoyages, commentaires: e })}
                  value={newLingesVoyages.commentaires}

                />
              </Grid>
              <Grid xs={12} md={12}>
                {errorsLingesVoyages.error ? (
                  <Typography variant="body2" color="error" textAlign={"center"}>
                    {errorsLingesVoyages.message}
                  </Typography>
                ) : null}
              </Grid>
              <Grid xs={12} md={10} sx={{ display: "flex", justifyContent: "center" }} >
                <ButtonAttribute
                  type="submit"
                  Label={"Ajouter Linges Voyages"}
                  Bgcolor="#17A2B8"
                  color="white"
                  action={handleAjouterLignesVoyages}
                />
              </Grid>
              <Divider sx={{ marginBottom: "20px" }} />
              <Grid xs={12} md={12} sx={{ display: "flex", justifyContent: "center" }}>
                {/* table show data  */}
                <TableContainer component={Paper} sx={{ width: "100%", overflow: "auto", maxHeight: "200px" }} >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Voyage Principal ID</TableCell>
                        <TableCell>Expéditeur</TableCell>
                        <TableCell>Destinataire</TableCell>
                        <TableCell>Statut</TableCell>
                        <TableCell>Commentaires</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody sx={{ bgcolor: "background.body", color: "text.primary" }} >
                      {LingesVoyages.map((voyage) => (
                        <TableRow key={voyage.id}>
                          <TableCell>{voyage.id}</TableCell>
                          <TableCell>{voyage.voyage_principal_id}</TableCell>
                          <TableCell>{voyage.expediteur}</TableCell>
                          <TableCell>{voyage.destinataire}</TableCell>
                          <TableCell>{voyage.statut}</TableCell>
                          <TableCell>{voyage.commentaires}</TableCell>
                          <TableCell>
                            {/* <IconButton onClick={() => handleEdit(voyage.id)}>
                    <FontAwesomeIcon icon={faEdit} />
                  </IconButton> */}
                            <IconButton onClick={() => handleDelete(voyage.id)}>
                              <FontAwesomeIcon icon={faTrash} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Box>
        </>}
      />

      {/* end  model Linges voyages by voyage */}

      {/* begin model modifier Voyage and multiple Voyages */}
      {/* begin model modifier Voyage */}
      <BasicModal
        open={openModifierVoyage}
        onClose={handleCloseModifier}
        widthSpecial="80%"
        ChildrenContent={
          rowsSelected.length === 1 ? (
            <>
              <Box
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "16px",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                  height: "85vh",
                  display: "flex",
                  flexDirection: "column",
                  p: 4,
                }}
              >
                {/* Header */}
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: "24px",
                    color: "#1D3E62",
                    fontWeight: 700,
                    textAlign: "center",
                    mb: 4,
                    borderBottom: "2px solid #1D3E62",
                    pb: 2,
                  }}
                >
                  Modifier Voyage ID: {modifierVoyage.ID_Voyage}
                </Typography>

                {/* Scrollable Content */}
                <Box sx={{ flex: 1, overflow: "auto", px: 2 }}>
                  {/* Informations Principales */}
                  <Box sx={{ mb: 4 }}>
                    <Typography
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        fontSize: "18px",
                        color: "#1D3E62",
                        fontWeight: 600,
                        mb: 2,
                      }}
                    >
                      <PersonIcon /> Informations Principales
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <AutocompleteComboBox
                          required
                          Label="Client facturation"
                          list={clients}
                          keyField="ID_Client"
                          valueField="Nom"
                          onChange={handleModifierSelectionChangeClient}
                          value={Number(modifierVoyage.Client_facturation)}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1 }}>
                          <FormControlLabel
                            control={<Radio checked={selectedTypeModifer === "Interne"} onChange={handleRadioChangeModifier} value="Interne" />}
                          />
                          <AutocompleteComboBox
                            disable={selectedTypeModifer.Interne}
                            required
                            widthSpecific="270px"
                            Label="Véhicules"
                            list={vehicules}
                            keyField="id"
                            valueField="matricule"
                            onChange={handleModifierSelectionChangeVehicule}
                            value={Number(modifierVoyage.ID_Vehicule)}
                            error={errors.error && !modifierVoyage.ID_Vehicule}
                            helperText={errors.error && !modifierVoyage.ID_Vehicule ? "Véhicule requis" : ""}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1 }}>
                          <FormControlLabel
                            control={<Radio checked={selectedTypeModifer === "Externe"} onChange={handleRadioChangeModifier} value="Externe" />}
                          />
                          <AutocompleteComboBox
                            disable={selectedTypeModifer.Externe}
                            required
                            widthSpecific="270px"
                            Label="Fournisseur"
                            list={fournisseurs}
                            keyField="id"
                            valueField="Nom"
                            onChange={handleModifierSelectionChangeFournisseur}
                            value={Number(modifierVoyage.Fournisseur)}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>

                  {/* Dates du Voyage */}
                  <Box sx={{ mb: 4 }}>
                    <Typography
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        fontSize: "18px",
                        color: "#1D3E62",
                        fontWeight: 600,
                        mb: 2,
                      }}
                    >
                      <CalendarTodayIcon /> Dates du Voyage
                    </Typography>

                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <DateTimePickerComponent
                          required
                          label="Date Chargement"
                          typeDate="datetime"
                          value={modifierVoyage.Date_chargement}
                          dateSelected={(date) => setModifierVoyage({ ...modifierVoyage, Date_chargement: date })}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <DateTimePickerComponent
                          typeDate="datetime"
                          label="Date Déchargement"
                          value={modifierVoyage.Date_déchargement}
                          dateSelected={(date) => setModifierVoyage({ ...modifierVoyage, Date_déchargement: date })}
                        />
                      </Grid>
                    </Grid>
                  </Box>

                  {/* Détails de l'Itinéraire */}
                  <Box sx={{ mb: 4 }}>
                    <Typography
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        fontSize: "18px",
                        color: "#1D3E62",
                        fontWeight: 600,
                        mb: 2,
                      }}
                    >
                      <LocationOnIcon /> Détails de l'Itinéraire
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <AutocompleteComboBox
                          required
                          widthSpecific="100%"
                          Label="Expéditeur - Destination"
                          list={villesTarification.filter((v) => v.ID_Client === modifierVoyage.Client_facturation)}
                          keyField="id"
                          departField="depart"
                          destinationField="destination"
                          dueShowValue
                          ToValue
                          onChange={(opt) => {
                            if (!opt) return;
                            setModifierVoyage((prev) => ({
                              ...prev,
                              ID_Tarification: opt.id,
                              Expediteur: opt.depart,
                              Destinataire: opt.destination,
                            }));
                          }}
                          value={parseInt(modifierVoyage.ID_Tarification)}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextInputMui
                          required
                          disabled
                          widthSpecific="100%"
                          label="Statut"
                          value={modifierVoyage.Statut}
                          onChange={(e) => setModifierVoyage({ ...modifierVoyage, Statut: e.target.value })}
                        />
                      </Grid>
                    </Grid>
                  </Box>

                  {/* Informations Complémentaires */}
                  <Box sx={{ mb: 1 }}>
                    <Typography
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        fontSize: "18px",
                        color: "#1D3E62",
                        fontWeight: 600,
                        mb: 2,
                      }}
                    >
                      <InfoIcon /> Informations +
                    </Typography>

                    <Grid container spacing={3}>
                      <Grid item xs={12} md={4}>
                        <AutocompleteComboBox
                          required
                          widthSpecific="100%"
                          Label="Type de Moyen"
                          list={[
                            { id: "taxi", Nom: "Taxi" },
                            { id: "T3_5", Nom: "Camion lourd 3/5 T" },
                            { id: "T7", Nom: "Camion léger 7 T" },
                            { id: "T14", Nom: "Camion lourd 14 T" },
                            { id: "T18", Nom: "Camion lourd 18 T" },
                            { id: "Tracteur", Nom: "Tracteur" },
                            { id: "semi_remorque", Nom: "Semi remorque" },
                          ]}
                          keyField="id"
                          valueField="Nom"
                          value={modifierVoyage.Type_de_moyen}
                          onChange={(key) => {
                            let coutTotal = "";
                            switch (key) {
                              case "taxi": coutTotal = destinationType.taxi; break;
                              case "T3_5": coutTotal = destinationType.T3_5; break;
                              case "T7": coutTotal = destinationType.T7; break;
                              case "T14": coutTotal = destinationType.T14; break;
                              case "T18": coutTotal = destinationType.T18; break;
                              case "semi_remorque": coutTotal = destinationType.semi_remorque; break;
                              case "Tracteur": coutTotal = destinationType.Tracteur; break;
                              default: coutTotal = "";
                            }
                            setModifierVoyage({ ...modifierVoyage, Type_de_moyen: key, Coût_Total: coutTotal });
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <AutocompleteComboBox
                          required
                          widthSpecific="100%"
                          Label="Type de Voyage"
                          list={[
                            { id: "Aller simple", Nom: "Aller simple" },
                            { id: "Aller retour", Nom: "Aller retour" },
                            { id: "Navette", Nom: "Navette" },
                            { id: "Groupage", Nom: "Groupage" },
                          ]}
                          keyField="Nom"
                          valueField="Nom"
                          value={modifierVoyage.Type_Voyage}
                          onChange={(key) => setModifierVoyage({ ...modifierVoyage, Type_Voyage: key })}
                        />
                      </Grid>

                      {["user-facture", "admin", "super-admin"].includes(role) && <Grid item xs={12} md={4}>
                        <TextInputMui
                          required
                          label="Coût Total"
                          type="number"
                          value={modifierVoyage.Coût_Total}
                          setValue={(e) => setModifierVoyage({ ...modifierVoyage, Coût_Total: e })}
                        />
                      </Grid>}
                    </Grid>
                  </Box>

                  {/* Documents */}
                  <Box sx={{ mb: 1, mt: 2 }}>
                    <Grid container spacing={2}>
                      {/* N° CMR multi */}
                      <Grid item xs={12} md={6} lg={4}>
                        <TextInputMuiMult
                          multiple
                          label="N° CMR"
                          values={Array.isArray(modifierVoyage.N_CMR) ? modifierVoyage.N_CMR : String(modifierVoyage.N_CMR ?? "").split(/[\/,;|\s]+/).filter(Boolean)}
                          setValues={(arr) => setModifierVoyage((p) => ({ ...p, N_CMR: arr }))}
                        />
                      </Grid>

                      {/* N° CMR RT multi if AR */}
                      {modifierVoyage.Type_Voyage === "Aller retour" && (
                        <Grid item xs={12} md={6} lg={4}>
                          <TextInputMuiMult
                            multiple
                            label="N° CMR Retour"
                            values={Array.isArray(modifierVoyage.N_CMR_RT) ? modifierVoyage.N_CMR_RT : String(modifierVoyage.N_CMR_RT ?? "").split(/[\/,;|\s]+/).filter(Boolean)}
                            setValues={(arr) => setModifierVoyage((p) => ({ ...p, N_CMR_RT: arr }))}
                          />
                        </Grid>
                      )}

                      {/* Scellés Douane multi IDs */}
                      <Grid item xs={12} md={6} lg={4}>
                        <SelectChips
                          required
                          widthSpecific="100%"
                          Label="Scellés Douane"
                          list={scellesOptions}
                          keyField="id"
                          valueField="numero_scelle"
                          value={Array.isArray(modifierVoyage.Scellés_Douane) ? modifierVoyage.Scellés_Douane : String(modifierVoyage.Scellés_Douane ?? "").split(/[\/,;|\s]+/).filter(Boolean).map(Number)}
                          ToValue={false}
                          onChange={(ids) => setModifierVoyage((p) => ({ ...p, Scellés_Douane: ids }))}
                        />
                      </Grid>

                      {/* DUM multi */}
                      <Grid item xs={12} md={modifierVoyage.Type_Voyage === "Aller retour" ? 4 : 2}>
                        <SelectChips
                          widthSpecific="100%"
                          Label="N° DUM"
                          list={listDUM.filter((d) => d.statut === "disponible")}
                          keyField="N_dum"
                          valueField="N_dum"
                          value={Array.isArray(modifierVoyage.N_DUM) ? modifierVoyage.N_DUM : String(modifierVoyage.N_DUM ?? "").split(/[\/,;|\s]+/).filter(Boolean)}
                          ToValue={false}
                          onChange={(vals) => setModifierVoyage((p) => ({ ...p, N_DUM: vals }))}
                        />
                      </Grid>

                      {/* DUM RT multi if AR */}
                      {modifierVoyage.Type_Voyage === "Aller retour" && (
                        <Grid item xs={12} md={6} lg={4}>
                          <SelectChips
                            widthSpecific="100%"
                            Label="N° DUM RT"
                            list={listDUM.filter((d) => d.statut === "disponible")}
                            keyField="N_dum"
                            valueField="N_dum"
                            value={Array.isArray(modifierVoyage.N_DUM_RT) ? modifierVoyage.N_DUM_RT : String(modifierVoyage.N_DUM_RT ?? "").split(/[\/,;|\s]+/).filter(Boolean)}
                            ToValue={false}
                            onChange={(vals) => setModifierVoyage((p) => ({ ...p, N_DUM_RT: vals }))}
                          />
                        </Grid>
                      )}

                      {/* Nombre palettes */}
                      <Grid item xs={12} md={6} lg={modifierVoyage.Type_Voyage === "Aller retour" ? 4 : 2}>
                        <TextInputMui
                          label="Nombre Palettes"
                          type="number"
                          value={modifierVoyage.Nombre_palettes}
                          setValue={(e) => setModifierVoyage({ ...modifierVoyage, Nombre_palettes: e })}
                        />
                      </Grid>

                      {/* Immobilisation */}
                      <Grid item xs={12} md={4}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={modifierVoyage.Immobilisation === "Oui"}
                              onChange={(e) => setModifierVoyage({ ...modifierVoyage, Immobilisation: e.target.checked ? "Oui" : "Non" })}
                              color="primary"
                              size="small"
                            />
                          }
                          label="Immobilisation"
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            border: "1px solid #E0E0E0",
                            borderRadius: "12px",
                            px: 1.5,
                            py: 0.8,
                            backgroundColor: "#F9FAFB",
                            width: "100%",
                            height: "45px",
                            fontSize: "14px",
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextInputMui
                          label="Nombre de jours Immobilisation"
                          type="number"
                          disabled={modifierVoyage.Immobilisation !== "Oui"}
                          value={modifierVoyage.N_jours}
                          setValue={(e) => setModifierVoyage({ ...modifierVoyage, N_jours: e })}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextInputMui
                          label="Prix Immobilisation"
                          type="number"
                          disabled={modifierVoyage.Immobilisation != "Oui"}
                          value={modifierVoyage.Prix_Immobilisation}
                          setValue={(e) => setModifierVoyage({ ...modifierVoyage, Prix_Immobilisation: e })}
                        />
                      </Grid>

                      {/* Prestation */}
                      <Grid item xs={12} md={4}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={modifierVoyage.Prestation === "Oui"}
                              onChange={(e) => setModifierVoyage({ ...modifierVoyage, Prestation: e.target.checked ? "Oui" : "Non" })}
                              color="primary"
                              size="small"
                            />
                          }
                          label="Prestation"
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            border: "1px solid #E0E0E0",
                            borderRadius: "12px",
                            px: 1.5,
                            py: 0.8,
                            backgroundColor: "#F9FAFB",
                            width: "100%",
                            height: "45px",
                            fontSize: "14px",
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextInputMui
                          label="Type Prestation"
                          type="text"
                          disabled={modifierVoyage.Prestation !== "Oui"}
                          value={modifierVoyage.Type_de_prestation}
                          setValue={(e) => setModifierVoyage({ ...modifierVoyage, Type_de_prestation: e })}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextInputMui
                          label="Prix Prestation"
                          type="number"
                          disabled={modifierVoyage.Prestation !== "Oui"}
                          value={modifierVoyage.Prix_Prestation}
                          setValue={(e) => setModifierVoyage({ ...modifierVoyage, Prix_Prestation: e })}
                        />
                      </Grid>

                      {/* Prix total voyage (roles) */}
                      {["user-facture", "admin", "super-admin"].includes(role) && (
                        <Grid item xs={12} md={4}>
                          <TextInputMui
                            label="Prix total voyage"
                            type="number"
                            value={modifierVoyage.prix_total_voyage}
                            setValue={(e) => setModifierVoyage({ ...modifierVoyage, prix_total_voyage: e })}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Box>
                </Box>

                {errorsModifer.error && (
                  <Typography variant="body2" color="error" align="center" sx={{ mt: 2 }}>
                    {errorsModifer.message}
                  </Typography>
                )}

                {/* Footer Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 2,
                    mt: 3,
                    pt: 3,
                    borderTop: "1px solid rgba(0,0,0,0.1)",
                  }}
                >
                  <ButtonAttribute
                    type="submit"
                    Label="Modifier le Voyage"
                    color="white"
                    Bgcolor="#FFC107"
                    height="45px"
                    width="200px"
                    action={handleOpenModifierOneVoyage}
                    sx={{
                      borderRadius: "8px",
                      textTransform: "none",
                      fontSize: "15px",
                      fontWeight: 600,
                      boxShadow: "0 4px 12px rgba(255, 193, 7, 0.2)",
                      "&:hover": { transform: "translateY(-2px)", boxShadow: "0 6px 16px rgba(255, 193, 7, 0.3)" },
                    }}
                  />
                  <ButtonAttribute
                    Label="Annuler"
                    color="#666"
                    Bgcolor="transparent"
                    height="45px"
                    width="120px"
                    action={handleCloseModifier}
                    sx={{
                      borderRadius: "8px",
                      textTransform: "none",
                      fontSize: "15px",
                      fontWeight: 500,
                      border: "1px solid #ddd",
                      "&:hover": { backgroundColor: "#f5f5f5" },
                    }}
                  />
                  {modifierVoyage.Type_Voyage === "Groupage" ? (
                    <ButtonAttribute
                      Label="Lignes Voyages"
                      color="#ffffff"
                      Bgcolor="#007bff"
                      height="45px"
                      width="160px"
                      action={handleOpenModifierLignesVoyages}
                      sx={{
                        borderRadius: "8px",
                        textTransform: "none",
                        fontSize: "15px",
                        fontWeight: 500,
                        border: "1px solid #ddd",
                        "&:hover": { backgroundColor: "#f5f5f5", color: "#007bff" },
                      }}
                    />
                  ) : null}
                </Box>
              </Box>
            </>
          ) : (
            <Typography
              variant="h4"
              sx={{
                fontSize: { lg: "20px", md: "20px", sm: "20px", xs: "20px" },
                mb: 2,
                fontFamily: "Montserrat , sans-serif",
                color: "#1D3E62",
                textAlign: "center",
                fontWeight: 600,
                p: "20px",
              }}
            >
              L'opération demandée est inexistante ou invalide. Les modifications multiples ne sont pas autorisées.
            </Typography>
          )
        }
      />
      {/* end model modifier Voyage */}

      {/* end  model modifier Voyage and multiple Voyages */}

      {/* begin show modifier Lignes Voyages  */}
      <BasicModal
        widthSpecial={'50%'}
        open={openModifierLignesVoyages}
        onClose={handleCloseModifierLignesVoyages}
        ChildrenContent={
          <Box sx={{ width: '100%', display: 'grid', justifyContent: 'center', alignContent: 'center' }}>
            <Typography
              variant="h4"
              sx={{
                fontSize: { lg: "35px", md: "30px", sm: "25px", xs: "20px" },
                mb: 2,
                fontFamily: "Montserrat , sans-serif",
                color: "#1D3E62",
                textAlign: "center",
                fontWeight: "bold",
                padding: "10px",
              }}
            >
              Lignes de Voyage N° : {modifierVoyage.ID_Voyage}
            </Typography>

            {/* Formulaire de modification */}
            <Grid container spacing={2} sx={{ mb: 3 }}>

              <Grid item xs={12} md={6}>
                <TextInputMui
                  label="Expéditeur"
                  value={ModifierLingesVoyage.expediteur}
                  setValue={(e) => setModifierLingesVoyage({ ...ModifierLingesVoyage, expediteur: e })}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '23px', border: '1px solid #ccc' } }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInputMui
                  label="Destinataire"
                  value={ModifierLingesVoyage.destinataire}
                  setValue={(e) => setModifierLingesVoyage({ ...ModifierLingesVoyage, destinataire: e })}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '23px', border: '1px solid #ccc' } }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextInputMui
                  label="Commentaires"
                  multiline
                  value={ModifierLingesVoyage.commentaires}
                  setValue={(e) => setModifierLingesVoyage({ ...ModifierLingesVoyage, commentaires: e })}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '23px', border: '1px solid #ccc' } }}
                />
              </Grid>

              {/* Action buttons */}
              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={12} md={6}>
                  <ButtonAttribute
                    type="submit"
                    Label="Modifier Ligne"
                    color="white"
                    Bgcolor="#17A2B8"
                    height={"50px"}
                    width={"100%"}
                    action={handleModifierLigneVoyage}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <ButtonAttribute
                    type="submit"
                    Label="Annuler"
                    color="white"
                    Bgcolor="gray"
                    height="50px"
                    width="100%"
                    action={handleCloseModifierLignesVoyages}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Tableau des lignes */}
            <TableContainer component={Paper} sx={{ width: "100%", overflow: "auto", maxHeight: "500px" }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Voyage Principal ID</TableCell>
                    <TableCell>Expéditeur</TableCell>
                    <TableCell>Destinataire</TableCell>
                    <TableCell>Statut</TableCell>
                    <TableCell>Commentaires</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody sx={{ bgcolor: "background.body", color: "text.primary" }}>
                  {LingesVoyages.map((voyage) => (
                    <TableRow
                      key={voyage.id}
                      hover
                      selected={voyage.id === ModifierLingesVoyage.id}
                      onClick={() => handleRowClick(voyage)}
                    >
                      <TableCell>{voyage.id}</TableCell>
                      <TableCell>{voyage.voyage_principal_id}</TableCell>
                      <TableCell>{voyage.expediteur}</TableCell>
                      <TableCell>{voyage.destinataire}</TableCell>
                      <TableCell>{voyage.statut}</TableCell>
                      <TableCell>{voyage.commentaires}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Note en bas */}
            <Typography
              variant="body2"
              sx={{
                mt: 2,
                fontStyle: "italic",
                textAlign: "center",
                color: "#666",
              }}
            >
              📝 Note : Cliquez sur une ligne du tableau pour la modifier ci-dessus.
            </Typography>
          </Box>
        }
      />


      {/* End show modifier Lignes Voyages  */}


      {/* Begin model Delete Voyage  and multiple Voyages */}
      <BasicModal
        open={openDeleteVoyage}
        onClose={handleCloseDeleteVoyage}
        ChildrenContent={
          rowsSelected.length === 1 ? (
            <>
              <Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: {
                      lg: "35px",
                      md: "30px",
                      sm: "25px",
                      xs: "20px",
                    },

                    fontFamily: "Montserrat , sans-serif",
                    color: "#1D3E62",
                    textAlign: "center",
                    fontWeight: "bold",
                    padding: "10px",
                  }}
                >
                  Suppression de la Voyage ID : {rowsSelected[0].ID_Voyage}{" "}
                </Typography>

                <Typography
                  variant="h6"
                  sx={{
                    fontSize: {
                      lg: "20px",
                      md: "16px",
                      sm: "14px",
                      xs: "14px",
                    },
                    mb: 1,
                    fontFamily: "Montserrat , sans-serif",
                    color: "#1D3E62",
                    textAlign: "center",

                    padding: "20px",
                  }}
                >
                  Voulez-vous vraiment supprimer cette Voyage ?
                </Typography>
                <Box
                  sx={{
                    display: {
                      xs: "grid2",
                      sm: "grid2",
                      md: "grid2",
                      lg: "flex",
                      xl: "flex",
                    },
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <ButtonAttribute
                    type="submit"
                    Label="Annuler"
                    color={"white"}
                    Bgcolor="gray"
                    height={"50px"}
                    width={"100%"}
                    action={handleCloseDeleteVoyage}
                  />
                  <ButtonAttribute
                    type="submit"
                    Label="Supprimer"
                    color={"white"}
                    Bgcolor="#DC3545"
                    height={"50px"}
                    width={"100%"}
                    action={handleOpenConfirmationPassword}
                  />
                </Box>
              </Box>
            </>
          ) : (
            <>
              <Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: {
                      lg: "35px",
                      md: "30px",
                      sm: "25px",
                      xs: "20px",
                    },
                    fontFamily: "Montserrat , sans-serif",
                    color: "#1D3E62",
                    textAlign: "center",
                    fontWeight: "bold",
                    padding: "10px",
                  }}
                >
                  Suppression des Voyages sélectionnées{" "}
                </Typography>

                <Typography
                  variant="h6"
                  sx={{
                    fontSize: {
                      lg: "20px",
                      md: "16px",
                      sm: "14px",
                      xs: "14px",
                    },
                    mb: 1,
                    fontFamily: "Montserrat , sans-serif",
                    color: "#1D3E62",
                    textAlign: "center",
                    padding: "20px",
                  }}
                >
                  Voulez-vous vraiment supprimer toutes les Voyages
                  sélectionnées ?
                </Typography>

                {rowsSelected.length > 1 ? (
                  <Box
                    sx={{
                      justifyContent: "center",
                      display: "flex",
                      gap: "5px",
                      width: "100%",
                      overflowX: "auto",
                      marginBottom: "20px",
                    }}
                  >
                    {rowsSelected.map((row, index) => (
                      <Box
                        key={index} // Use a unique key. Ideally, use a unique identifier from `row` if available.
                        sx={{
                          display: "grid",
                          justifyContent: "center",
                          alignItems: "center",
                          marginBottom: "20px",

                          padding: "10px",
                          width: "50px",
                          height: "40px",
                          borderRadius: "10%",
                          backgroundColor: "#DC3545",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            color: "#fff",
                            fontSize: 14,
                            textAlign: "center",
                            fontFamily: "Montserrat, sans-serif",
                          }}
                        >
                          {row.ID_Voyage || "N/A"}{" "}
                          {/* Safeguard in case `id` is undefined */}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                ) : null}

                <Box
                  sx={{
                    display: {
                      xs: "grid2",
                      sm: "grid2",
                      md: "grid2",
                      lg: "flex",
                      xl: "flex",
                    },
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <ButtonAttribute
                    type="submit"
                    Label="Annuler"
                    color={"white"}
                    Bgcolor="gray"
                    height={"50px"}
                    width={"100%"}
                    action={handleCloseDeleteVoyage}
                  />
                  <ButtonAttribute
                    type="submit"
                    Label="Supprimer toutes"
                    color={"white"}
                    Bgcolor="#DC3545"
                    height={"50px"}
                    width={"100%"}
                    action={handleOpenConfirmationPassword}
                  />
                </Box>
              </Box>
            </>
          )
        }
      />
      {/* end model Delete Voyage  and multiple Voyages */}

      {/* begin model export Voyage */}
      <BasicModal
        open={openExtrationVoyage}
        onClose={handleCloseExtrationVoyage}
        ChildrenContent={
          <>
            <Box>
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: "35px", md: "30px", sm: "25px", xs: "20px" },

                  fontFamily: "Montserrat , sans-serif",
                  color: "#1D3E62",
                  textAlign: "center",
                  fontWeight: "bold",
                  padding: "10px",
                }}
              >
                Extraction des données voyages{" "}
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  fontSize: { lg: "20px", md: "16px", sm: "14px", xs: "14px" },
                  mb: 1,
                  fontFamily: "Montserrat , sans-serif",
                  color: "#1D3E62",
                  textAlign: "center",
                  padding: "20px",
                }}
              >
                Vous disposez de deux types d'extraction des transactions. Si
                vous souhaitez extraire l'intégralité des données ou uniquement
                certains éléments, merci de les préciser dans le tableau.
              </Typography>

              <Box
                sx={{
                  display: {
                    xs: "grid2",
                    sm: "grid2",
                    md: "grid2",
                    lg: "flex",
                    xl: "flex",
                  },
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  gap: "30px",
                }}
              >
                <ButtonAttribute
                  type="button"
                  Label="Extraire toutes les données ( XLSX )"
                  Bgcolor="#17A2B8"
                  color="white"
                  bgColorHover={"#117A8B"}
                  height={"70px"}
                  width={"100%"}
                  endIcon={<FontAwesomeIcon icon={faDownload} color="white" />}
                  action={handleExtrationAllVoyage}
                />
                <ButtonAttribute
                  type="submit"
                  Label="Extraire les données sélectionnées ( XLSX )"
                  Bgcolor="#17A2B8"
                  color="white"
                  bgColorHover={"#117A8B"}
                  height={"70px"}
                  width={"100%"}
                  action={handleExtrationSelectionsVoyages}
                  endIcon={<FontAwesomeIcon icon={faDownload} color="white" />}
                />
              </Box>
            </Box>
          </>
        }
      />
      {/* end  model export Voyage */}

      {/* begin model importation Voyage */}
      <BasicModal
        open={openImportationVoyage}
        onClose={handleCloseImportationVoyage}
        ChildrenContent={
          <>
            <Box>
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: "35px", md: "30px", sm: "25px", xs: "20px" },

                  fontFamily: "Montserrat , sans-serif",
                  color: "#1D3E62",
                  textAlign: "center",
                  fontWeight: "bold",
                  padding: "10px",
                }}
              >
                Importation des données de voyage{" "}
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  fontSize: { lg: "20px", md: "16px", sm: "14px", xs: "14px" },
                  mb: 1,
                  fontFamily: "Montserrat , sans-serif",
                  color: "#1D3E62",
                  textAlign: "center",
                  padding: "20px",
                }}
              >
                {" "}
                Veuillez utiliser ce formulaire pour importer les Voyages depuis
                un fichier Excel{" "}
              </Typography>
              <ButtonAttribute
                type="button"
                Label="Télécharger le formulaire Excel"
                Bgcolor="#17A2B8"
                color="white"
                bgColorHover={"#117A8B"}
                height={"80px"}
                width={"100%"}
                endIcon={<FontAwesomeIcon icon={faDownload} color="white" />}
                action={handleDownload}
              />
              <Divider />
              <Box
                sx={{
                  display: "grid",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: {
                      lg: "20px",
                      md: "16px",
                      sm: "14px",
                      xs: "14px",
                    },
                    mb: 1,
                    fontFamily: "Montserrat , sans-serif",
                    color: "#1D3E62",
                    textAlign: "center",
                    padding: "20px",
                  }}
                >
                  {" "}
                  Cliquez sur le bouton ci-dessous pour sélectionner et importer
                  votre fichier.
                </Typography>
                <ButtonAttribute
                  type="button"
                  Label="Importer toutes les données de Voyages"
                  Bgcolor="#17A2B8"
                  color="white"
                  bgColorHover={"#117A8B"}
                  height={"70px"}
                  width={"100%"}
                  endIcon={
                    <FontAwesomeIcon icon={faCloudArrowUp} color="white" />
                  }
                  action={triggerFileInput}
                />
                <input
                  id="file-upload"
                  type="file"
                  accept=".xlsx, .xls , .csv"
                  style={{ display: "none" }}
                  onChange={handleFileImport}
                />
                <CustomizedProgressBars
                  value={isLoading}
                  color={
                    importStatus === "success"
                      ? "success"
                      : importStatus === "error"
                        ? "error"
                        : importStatus === "processing"
                          ? "primary"
                          : "gray"
                  }
                />
              </Box>
            </Box>
          </>
        }
      />

      {/* end model importation Voyage */}

      {/* begin model confirmation password delete Voyages */}

      <BasicModal
        open={openConfirmationPassword}
        onClose={handleCloseConfirmationPassword}
        ChildrenContent={
          <>
            <Box>
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: "35px", md: "30px", sm: "25px", xs: "20px" },
                  fontFamily: "Montserrat , sans-serif",
                  color: "#1D3E62",
                  textAlign: "center",
                  fontWeight: "bold",
                  padding: "20px",
                  marginBottom: "20px",
                }}
              >
                Veuillez saisir votre mot de passe pour confirmer la suppression
                de la Voyage
              </Typography>
              <Box
                sx={{
                  display: "grid",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <TextInputMui
                  type="password"
                  label="Mot de passe"
                  name="password"
                  value={ConfrimedPassword.password}
                  setValue={(e) =>
                    setConfirmedPassword({ ...ConfrimedPassword, password: e })
                  }
                  required
                />
                <ButtonAttribute
                  type="submit"
                  Label="Confirmer la suppression"
                  Bgcolor="#17A2B8"
                  color="white"
                  bgColorHover={"#117A8B"}
                  height={"50px"}
                  width={"100%"}
                  endIcon={<FontAwesomeIcon icon={faCheck} color="white" />}
                  action={handleVerificationPassword}
                />
              </Box>
            </Box>
          </>
        }
      />


      <BasicModal
        open={openChangeStatuVoyage}
        onClose={handleCloseChangeStatuVoyage}
        ChildrenContent={
          VoyageStatus.length === 1 ?
            <>
              <Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: { lg: "30px", md: "30px", sm: "25px", xs: "20px" },
                    fontFamily: "Montserrat , sans-serif",
                    color: "#1D3E62",
                    textAlign: "center",
                    fontWeight: "bold",
                    padding: "20px",
                    marginBottom: "20px",
                  }}
                >
                  Veuillez change le statut de la Voyage {VoyageStatus[0].ID_Voyage}
                </Typography>
                <Box
                  sx={{
                    display: "grid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  {/* Stepper */}

                  <Stepper sx={{ width: "100%", gap: "30px" }} activeStep={VoyageStatus[0].Statut === "Réserver" ? 0 : VoyageStatus[0].Statut === "En cours" ? 1 : 3} alternativeLabel>
                    {["Réserver", "En cours"].map((label) => (
                      <Step sx={{ fontSize: "30px" }} key={label}>
                        <StepLabel sx={{ fontSize: "20px" }}>{label}</StepLabel> {/* Apply fontSize to StepLabel */}
                      </Step>
                    ))}
                  </Stepper>

                  {VoyageStatus[0].Statut === "En cours" ? <>

                    <Typography
                      variant="h4"
                      sx={{
                        fontSize: { lg: "30px", md: "30px", sm: "25px", xs: "20px" },
                        fontFamily: "Montserrat , sans-serif",
                        color: "#1D3E62",
                        textAlign: "center",
                        fontWeight: "bold",
                        padding: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      Status actuel déja en cours
                    </Typography>

                  </> :
                    <ButtonAttribute
                      type="submit"
                      Label="Confirmer changement"
                      Bgcolor="#17A2B8"
                      color="white"
                      bgColorHover={"#117A8B"}
                      height={"50px"}
                      width={"100%"}
                      endIcon={<FontAwesomeIcon icon={faCheck} color="white" />}
                      action={handleChangeStatus}
                    />}

                </Box>
              </Box>
            </>
            :
            <>
              <Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: { lg: "30px", md: "30px", sm: "25px", xs: "20px" },
                    fontFamily: "Montserrat , sans-serif",
                    color: "#1D3E62",
                    textAlign: "center",
                    fontWeight: "bold",
                    padding: "20px",
                    marginBottom: "20px",
                  }}
                >
                  Veuillez change les statuts des Voyages :
                </Typography>

                <Box
                  sx={{
                    display: "grid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  {/* Stepper */}
                  {(VoyageStatus?.length > 0 ? VoyageStatus : []).map((row, index) => (<>
                    <Box sx={{ display: "flex", justifyContent: "space-between", }} >
                      <Box
                        key={index} // Use a unique key. Ideally, use a unique identifier from `row` if available.
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          marginBottom: "20px",

                          padding: "10px",
                          width: "50px",
                          height: "40px",
                          borderRadius: "10%",
                          backgroundColor: "#17A2B8",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            color: "#fff",
                            fontSize: 14,
                            textAlign: "center",
                            fontFamily: "Montserrat, sans-serif",
                          }}
                        >
                          {row.ID_Voyage || "N/A"}{" "}
                          {/* Safeguard in case `id` is undefined */}
                        </Typography>
                      </Box>
                      <Stepper sx={{ width: "100%", gap: "30px" }} activeStep={row.Statut === "Réserver" ? 0 : row.Statut === "Prévu" ? 1 : row.Statut === "En cours" ? 3 : 2} alternativeLabel>
                        {["Réserver", "En cours"].map((label) => (
                          <Step sx={{ fontSize: "30px" }} key={label}>
                            <StepLabel sx={{ fontSize: "20px" }}>{label}</StepLabel> {/* Apply fontSize to StepLabel */}
                          </Step>
                        ))}
                      </Stepper>
                    </Box>
                  </>
                  ))}
                  <ButtonAttribute

                    type="submit"
                    Label="Confirmer changement"
                    Bgcolor="#17A2B8"
                    color="white"
                    bgColorHover={"#117A8B"}
                    height={"50px"}
                    width={"100%"}
                    endIcon={<FontAwesomeIcon icon={faCheck} color="white" />}
                    action={handleChangeStatusMultiVoyages}
                  />
                </Box>
              </Box>
            </>

        }
      />


      {/* alert for ajouter */}
      <AlertBar
        open={alertOpen}
        onClose={handleAlertClose}
        textContent="La Voyage a été ajoutée avec succès."
        alertColor="success"
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      />
      {/* alert for ajouter */}

      {/* alert for modifier */}
      <AlertBar
        open={alertOpenSelectedModifier}
        onClose={handleAlertCloseSelectedModifier}
        textContent="Veuillez choisir une ligne"
        alertColor="warning"
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      />
      {/* not modifer line  row  */}

      <AlertBar
        open={alertOpenNotModiferRow}
        onClose={handleAlertCloseNotModiferRow}
        textContent={
          "Aucune des informations n'a été modifiée, donc je ne vais pas effectuer l'opération."
        }
        alertColor={"info"}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
      {/*  alert for modifier success */}
      <AlertBar
        open={alertOpenUpdatedVoyage}
        onClose={handleAlertCloseUpdatedVoyage}
        textContent="Voyage mise à jour avec succès"
        alertColor="success"
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      />
      {/*  alert for modifier  */}

      {/* alert for delete Voyage one row  */}
      <AlertBar
        open={alertOpenDeletedVoyage}
        onClose={handleAlertCloseDeletedVoyage}
        textContent="Voyage supprimée avec succès "
        alertColor="success"
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      />
      <AlertBar
        open={alertOpenPasswordNotValid}
        onClose={handleAlertClosePasswordNotValid}
        textContent="Mot de passe incorrect pour supprimer la Voyage"
        alertColor="error"
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      />
      <AlertBar
        open={alertOpenMultiDeletedVoyage}
        onClose={handleAlertMultiCloseDeletedVoyage}
        textContent="Toutes les Voyages ont été supprimées avec succès."
        alertColor="success"
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      />
      {/* end alert for delete Voyage one row  */}

      {/* alert for extration Voyage   */}
      <AlertBar
        open={alertOpenNotSelectedLineExtration}
        onClose={handleAlertCloseNotSelectedLineExtration}
        textContent={
          "Veuillez préciser les lignes que vous souhaitez extraire pour télécharger le fichier au format .csv"
        }
        alertColor={"info"}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
      {/* alert for importation Voyage   */}
      <AlertBar
        open={alertOpenImport}
        onClose={handleCloseAlertImport}
        textContent="Importation effectuée avec succès ! Les données ont été ajoutées correctement"
        alertColor="success"
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      />
      <AlertBar
        open={alertErrorImport}
        onClose={handleCloseErrorAlertImport}
        textContent="Importation non effectuée : le fichier contient des erreurs ou les valeurs sont incorrectes. Veuillez vérifier et réessayer."
        alertColor="error"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
      {/* end alert for importation Voyage   */}

      {/* begin alert confirmation password delete Voyages */}
      <AlertBar
        open={alertOpenConfirmDeleteVoyage}
        onClose={handleCloseAlertConfirmDeleteVoyage}
        textContent="le mot de passe est incorrect !"
        alertColor="error"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
      {/* end alert confirmation password delete Voyages */}

      {/* drawer for new client */}
      <CustomDrawer

        open={DrawerClientOpen}
        onToggle={(open) => setDrawerClientOpen(open)}
      >
        <Box sx={{ width: { xs: "100%", sm: "100%", md: "100%", lg: "400px", xl: "500px" }, mt: "40px", borderRadius: "16px" }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#1a1a1a",
              fontFamily: "Montserrat, sans-serif",
              textAlign: "center",
              mb: "24px",
            }}
          >
            Nouveau Client
          </Typography>
          <Divider sx={{ marginBottom: "24px" }} />
          <Grid container spacing={1} sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '12px',
            color: '#1D3E62',
            gap: '1.5px',
            overflowY: 'scroll',

          }} >


            <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
              <TextInputMui
                required={true}
                label="Nom"
                type="text"
                value={newClient.Nom}
                setValue={(e) => setNewClient({ ...newClient, Nom: e })}
              // User Icon for Email
              />
            </Grid>
            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
              <TextInputMui
                required={true}
                label="Code Client"
                type="text"
                value={newClient.Code_client}
                setValue={(e) => setNewClient({ ...newClient, Code_client: e })}
              // User Icon for Email
              />
            </Grid>
            <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
              <TextInputMui
                label="Adresse"
                type="text"
                value={newClient.Adresse}
                setValue={(e) => setNewClient({ ...newClient, Adresse: e })}
              // User Icon for Email
              />
            </Grid>
            <Grid item xs={12} sm={12} md={10} lg={5} xl={5} >
              <TextInputMui
                required={true}
                label="Email"
                type="email"
                value={newClient.Email}
                setValue={(e) => setNewClient({ ...newClient, Email: e })}
              // User Icon for Email
              />
            </Grid>
            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
              <TextInputMui
                required={true}
                label="Contact"
                type="tel"
                value={newClient.Contact}
                setValue={(e) => setNewClient({ ...newClient, Contact: e })}
              // User Icon for Email
              />
            </Grid>
            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
              <AutocompleteComboBox
                required={true}
                widthSpecific={'100%'}
                Label={"Type Client"}
                list={typeClients}
                keyField={'label'}
                valueField={'value'}
                value={newClient.Type_Client}
                onChange={(e) => setNewClient({ ...newClient, Type_Client: e })}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
              <TextInputMui
                label="Raison Sociale"
                type="text"
                value={newClient.Raison_sociale}
                setValue={(e) => setNewClient({ ...newClient, Raison_sociale: e })}
              // User Icon for Email
              />
            </Grid>
            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
              <TextInputMui
                label="Forme Juridique"
                type="text"
                value={newClient.Forme_juridique}
                setValue={(e) => setNewClient({ ...newClient, Forme_juridique: e })}
              // User Icon for Email
              />
            </Grid>

            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
              <TextInputMui
                label="Les sites"
                type="text"
                value={newClient.Sites}
                setValue={(e) => setNewClient({ ...newClient, Sites: e })}
              // User Icon for Email
              />
            </Grid>
            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
              <TextInputMui
                label="Identifiant fiscale"
                type="text"
                value={newClient.IF}
                setValue={(e) => setNewClient({ ...newClient, IF: e })}
              // User Icon for Email
              />
            </Grid>
            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
              <TextInputMui
                label="ICE"
                type="text"
                value={newClient.ICE}
                setValue={(e) => setNewClient({ ...newClient, ICE: e })}
              // User Icon for Email
              />
            </Grid>
            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
              <TextInputMui
                label="Taux de TVA"
                type="text"
                value={newClient.taux_de_TVA}
                setValue={(e) => setNewClient({ ...newClient, taux_de_TVA: e })}
              // User Icon for Email
              />
            </Grid>

            <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
              <AutocompleteComboBox
                widthSpecific={'100%'}
                Label={"Mode de reglement"}
                value={newClient.Mode_de_reglement}
                onChange={(e) => setNewClient({ ...newClient, Mode_de_reglement: e })}
                list={[
                  { value: 'Espèces ', label: 'Espèces' },
                  { value: 'Virement Bancaire', label: 'Virement Bancaire' },
                  { value: 'Chèque', label: 'Chèque' },
                  { value: 'Carte Bancaire', label: 'Carte Bancaire' },
                  { value: 'Prélèvement Automatique', label: 'Prélèvement Automatique' },
                ]}
                valueField={'label'}
                keyField={'label'}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
              <TextInputMui
                label="Echeance de reglement"
                type="number"
                value={newClient.Echéance_de_reglement}
                setValue={(e) => setNewClient({ ...newClient, Echéance_de_reglement: e })}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
              <TextInputMui
                label="Activite"
                type="text"
                value={newClient.Activité}
                setValue={(e) => setNewClient({ ...newClient, Activité: e })}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              {errorsClient.error === true ? (
                <Typography variant='subtitle1' component="p" sx={{
                  color: 'red',
                  textAlign: 'center',
                }}>  {errorsClient.message} </Typography>
              ) : null}
            </Grid>

            <Grid xs={12} sm={12} md={12} lg={12} xl={12} sx={{
              display: 'flex', justifyContent: 'center', alignItems: 'center',
              mt: '20px'
            }} >
              <Box sx={{
                width: { xs: '150px', sm: '200px', md: '300px', lg: '300px', xl: '400px' },
                display: 'flex', justifyContent: 'center', alignItems: 'center'
              }}>
                <ButtonAttribute
                  type="submit"
                  Label="Ajouter le client"
                  color={'white'}
                  Bgcolor='#28A745'
                  height={'60px'}
                  width={'100%'}
                  action={() => {
                    handleAjouterClient();
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </CustomDrawer>

      {/* begin alert nouveau client */}
      <AlertBar
        open={alertOpenNouveauClient}
        onClose={handleCloseAlertNouveauClient}
        textContent="Le client a été ajoutée avec succès."
        alertColor="success"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
      {/* end alert nouveau client */}

      {/* drawer for new vehicle */}

      <CustomDrawer
        open={DrawerVehiculeOpen}
        onToggle={(open) => setDrawerVehiculeOpen(open)}
      >
        <Box sx={{ mt: "20px", mb: "20px", display: "grid", justifyContent: "center", alignItems: "center", gap: "5px" }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#333",
              fontFamily: "Montserrat , sans-serif",
              textAlign: "center",
              border: "1px solid #ddd",
              borderRadius: "18px",
              p: "20px",
              m: "20px",
            }}
          >
            Nouveau Véhicule
          </Typography>

          <Box sx={{ display: "grid", justifyContent: "center", alignItems: "center", gap: "10px", p: "5px 20px" }}>
            {/* Code véhicule (unique) */}
            <TextInputMui
              required
              label="Code véhicule"
              type="text"
              value={newVehicule.code_vehicule || ""}
              setValue={(e) => setNewVehicule({ ...newVehicule, code_vehicule: e })}
            />

            <TextInputMui
              required
              label="Marque"
              type="text"
              value={newVehicule.marque}
              setValue={(e) => setNewVehicule({ ...newVehicule, marque: e })}
            />

            <TextInputMui
              required
              label="Matricule"
              type="text"
              value={newVehicule.matricule}
              setValue={(e) => setNewVehicule({ ...newVehicule, matricule: e })}
            />

            <AutocompleteComboBox
              required
              widthSpecific="100%"
              Label="Type de Moyen"
              list={[
                { id: "taxi", Nom: "Taxi" },
                { id: "T3_5", Nom: "Camion lourd T3/5" },
                { id: "T7", Nom: "Camion léger T7" },
                { id: "T14", Nom: "Camion lourd T14" },
                { id: "T18", Nom: "Camion lourd T18" },
                { id: "semi_remorque", Nom: "Semi remorque" },
                { id: "Tracteur", Nom: "Tracteur" },
              ]}
              keyField="id"
              valueField="Nom"
              value={newVehicule.type_moyen}
              onChange={(v) => setNewVehicule({ ...newVehicule, type_moyen: v })}
            />

            <AutocompleteComboBox
              required
              Label="Chauffeur Responsable"
              widthSpecific="100%"
              keyField="id"
              valueField="Nom"
              DeméValue="Prénom"
              DueValue
              dueShowValue
              value={newVehicule.id_chauffeur}
              onChange={(v) => setNewVehicule({ ...newVehicule, id_chauffeur: v })}
              list={chauffeurs}
            />

            <TextInputMui
              required
              label="Numéro de châssis"
              type="text"
              value={newVehicule.numero_chassis}
              setValue={(e) => setNewVehicule({ ...newVehicule, numero_chassis: e })}
            />

            <DateTimePickerComponent
              typeDate="date"
              label="Première mise en circulation"
              dateSelected={(d) => setNewVehicule({ ...newVehicule, premiere_mise_en_circulation: d })}
              value={newVehicule.premiere_mise_en_circulation}
            />

            <DateTimePickerComponent
              typeDate="date"
              label="Première mise au Maroc"
              dateSelected={(d) => setNewVehicule({ ...newVehicule, premiere_mise_au_maroc: d })}
              value={newVehicule.premiere_mise_au_maroc}
            />

            <TextInputMui
              label="PTAC"
              type="number"
              value={newVehicule.ptac}
              setValue={(e) => setNewVehicule({ ...newVehicule, ptac: e })}
            />

            <TextInputMui
              label="Poids à vide"
              type="number"
              value={newVehicule.poids_vide}
              setValue={(e) => setNewVehicule({ ...newVehicule, poids_vide: e })}
            />

            <DateTimePickerComponent
              typeDate="date"
              label="Date d'acquisition"
              dateSelected={(d) => setNewVehicule({ ...newVehicule, date_acquisition: d })}
              value={newVehicule.date_acquisition}
            />

            {/* Type d’acquisition */}
            <AutocompleteComboBox
              Label="Type d'acquisition"
              widthSpecific="100%"
              list={[
                { id: "leasing", Nom: "Leasing" },
                { id: "comptant", Nom: "Comptant" },
              ]}
              keyField="id"
              valueField="Nom"
              value={newVehicule.type_acquisition}
              onChange={(v) =>
                setNewVehicule((prev) => ({
                  ...prev,
                  type_acquisition: v,
                  ...(v === "leasing"
                    ? {}
                    : {
                      date_premier_prelevement: "",
                      date_dernier_prelevement: "",
                      nombre_prelevements: "",
                      montant_loyer_ttc: "",
                    }),
                }))
              }
            />

            {/* Champs leasing conditionnels */}
            {newVehicule.type_acquisition === "leasing" && (
              <>
                <DateTimePickerComponent
                  typeDate="date"
                  label="Date premier prélèvement"
                  dateSelected={(d) => setNewVehicule({ ...newVehicule, date_premier_prelevement: d })}
                  value={newVehicule.date_premier_prelevement}
                />
                <DateTimePickerComponent
                  typeDate="date"
                  label="Date dernier prélèvement"
                  dateSelected={(d) => setNewVehicule({ ...newVehicule, date_dernier_prelevement: d })}
                  value={newVehicule.date_dernier_prelevement}
                />
                <TextInputMui
                  label="Nombre de prélèvements"
                  type="number"
                  value={newVehicule.nombre_prelevements || ""}
                  setValue={(e) => setNewVehicule({ ...newVehicule, nombre_prelevements: e })}
                />
                <TextInputMui
                  label="Montant loyer TTC"
                  type="number"
                  value={newVehicule.montant_loyer_ttc}
                  setValue={(e) => setNewVehicule({ ...newVehicule, montant_loyer_ttc: e })}
                />
              </>
            )}

            <TextInputMui
              label="Valeur d'achat"
              type="number"
              value={newVehicule.valeur_achat}
              setValue={(e) => setNewVehicule({ ...newVehicule, valeur_achat: e })}
            />

            <AutocompleteComboBox
              Label="Carburant véhicule"
              widthSpecific="100%"
              keyField="id"
              valueField="Nom"
              value={newVehicule.carburant}
              onChange={(v) => setNewVehicule({ ...newVehicule, carburant: v })}
              list={[
                { id: "Diesel", Nom: "Diesel" },
                { id: "Essence", Nom: "Essence" },
                { id: "Electrique", Nom: "Electrique" },
                { id: "Hybride", Nom: "Hybride" },
              ]}
            />

            <TextInputMui
              label="N° police d'assurance"
              type="text"
              value={newVehicule.numero_police_assurance}
              setValue={(e) => setNewVehicule({ ...newVehicule, numero_police_assurance: e })}
            />

            <DateTimePickerComponent
              typeDate="date"
              label="Date d'expiration assurance"
              dateSelected={(d) => setNewVehicule({ ...newVehicule, date_expiration_assurance: d })}
              value={newVehicule.date_expiration_assurance}
            />

            {/* GPS installé */}
            <FormControlLabel
              control={
                <Switch
                  checked={!!newVehicule.gps_installe}
                  onChange={(e) => setNewVehicule({ ...newVehicule, gps_installe: e.target.checked })}
                  color="primary"
                />
              }
              label="GPS installé"
            />

            <AutocompleteComboBox
              Label="Statut véhicule"
              widthSpecific="100%"
              list={[
                { id: "actif", Nom: "Actif" },
                { id: "inactif", Nom: "Inactif" },
                { id: "vendu", Nom: "Vendu" },
                { id: "endommagé", Nom: "Endommagé" },
              ]}
              keyField="id"
              valueField="Nom"
              DueValue
              dueShowValue
              value={newVehicule.statut || "actif"}
              onChange={(v) => setNewVehicule({ ...newVehicule, statut: v })}
            />

            {errorsVehicule.error && (
              <Typography variant="body2" color="error">
                {errorsVehicule.message}
              </Typography>
            )}

            <ButtonAttribute
              type="submit"
              Label={"Ajouter Véhicule"}
              Bgcolor="#17A2B8"
              color="white"
              action={handleAjouterVehicule}
              disabled={isSubmittingVehicule}
            />
          </Box>
        </Box>
      </CustomDrawer>


      {/* begin alert nouveau Vehicule */}
      <AlertBar
        open={alertOpenNouveauVehicule}
        onClose={handleCloseAlertNouveauVehicule}
        textContent="Le vehicule a été ajoutée avec succès."
        alertColor="success"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
      {/* end alert nouveau Vehicule */}

      {/* drawer for new Fournisseur */}

      <CustomDrawer
        open={DrawerFournisseurOpen}
        onToggle={(open) => setDrawerFournisseurOpen(open)}
      >
        <Box sx={{ padding: "24px" }}>
          <Typography
            variant="h5"
            sx={{ textAlign: "center", fontWeight: "bold", marginBottom: "16px" }}
          >
            Nouveau Fournisseur
          </Typography>
          <Divider sx={{ marginBottom: "16px" }} />
          <Box
            sx={{
              display: "grid",
              justifyContent: "center",
              alignItems: "center",
              gap: "20px",
              p: "30px 20px 5px 20px",
            }}
          >
            <TextInputMui
              type={"text"}
              label={"Matricule"}
              setValue={(e) =>
                setNewFournisseur({ ...newFournisseur, Matricule: e })
              }
              value={newFournisseur.Matricule}
              required
            />
            <TextInputMui
              type={"text"}
              label={"Nom"}
              setValue={(e) => setNewFournisseur({ ...newFournisseur, Nom: e })}
              value={newFournisseur.Nom}

            />

            <TextInputMui
              type={"tel"}
              label={"Contact"}
              setValue={(e) =>
                setNewFournisseur({ ...newFournisseur, Contact: e })
              }
              value={newFournisseur.Contact}

            />
            <TextInputMui
              type={"number"}
              label={"PrixAchat"}
              setValue={(e) =>
                setNewFournisseur({ ...newFournisseur, Cout_Achat: e })
              }
              value={newFournisseur.Cout_Achat}
              required
            />


            {errorsFournisseur.error ? (
              <Typography variant="body2" color="error">
                {errorsFournisseur.message}
              </Typography>
            ) : null}
            <ButtonAttribute
              type="submit"
              Label={"Ajouter Fournisseur"}
              Bgcolor="#17A2B8"
              color="white"
              action={handleAjouterFournisseur}
            />
          </Box>
        </Box>
      </CustomDrawer>
      {/*  end drawer for new Fournisseur */}


      {/* drawer for new LingesVoyages */}



      {/*  end drawer for new LingesVoyages */}




      <ConfirmationDialog />
      <ConfirmationMultiVoyagesDialog />


      <AlertBar
        open={alertOpenAnnulation}
        onClose={handleAlertCloseAnnulation}
        severity="success"
        textContent="Le voyage a été annulé avec succès"
      />
      <ConfirmAnnulationDialog />
      <AnnulationDialog />

      {/* Alertes pour les statuts */}
      <AlertBar
        open={alertVoyageDejaTermine}
        onClose={() => setAlertVoyageDejaTermine(false)}
        severity="error"
        textContent="Ce voyage est déjà Réalisé. Impossible de modifier son statut."
        alertColor="error"
      />

      <AlertBar
        open={alertVoyageDejaAnnule}
        onClose={() => setAlertVoyageDejaAnnule(false)}
        severity="error"
        textContent="Ce voyage est déjà annulé. Impossible de modifier son statut."
        alertColor="error"
      />
      {/* Alertes pour les statuts changements */}
      <AlertBar
        open={alertVoyageStatusUpadate}
        onClose={handleCloseAlertStatusUpdate}
        severity="Success"
        textContent="Le statut du voyage a bien changer ."
        alertColor="success"
      />
      <AlertBar
        open={alertVoyageDejaEnCours}
        onClose={handleCloseAlertDejaEnCours}
        severity="error"
        textContent="Ce voyage est déjà en cours. Impossible de modifier son statut."
        alertColor="error"
      />
      <AlertBar
        open={alertLigneDeVoyage}
        onClose={handleCloseAlertLigneDeVoyage}
        severity="Success"
        textContent=" La ligne de voyage a été ajoutée avec succès."
        alertColor="success"
      />
      <AlertBar
        open={alertDeleteLigneDeVoyage}
        onClose={handleCloseAlertDeleteLigneDeVoyage}
        severity="Success"
        textContent=" La ligne de voyage a été Supprimée avec succès."
        alertColor="success"
      />

      {/* Alert for Modifier linges voyages  */}
      <AlertBar
        open={alertOpenModifierLingesVoyages}
        onClose={handleAlertCloseModifierLingesVoyages}
        severity="success"
        textContent="La ligne de voyage a été modifiée avec succès."
      />

      {/* Dialog for comfier linges ajouter  */}
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openDialogConfimerAjouter}
        onClose={handleCloseDialogConfimerAjouter}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Confirmer la fermeture du formulaire ?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Confirmez-vous l'enregistrement de ce voyage ainsi que de ses lignes de voyage ? Les informations saisies seront ajoutées à la liste. Souhaitez-vous quitter sans enregistrer les lignes de voyage ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogConfimerAjouter} autoFocus>
            Annuler
          </Button>
          <Button onClick={handleConfirmerClose}>
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for comfier linges ajouter  */}


      {/* begin for Modifier linges voyages  */}
    </ThemeProvider>
  );
}